import AcademyReplyOptions from "./AcademyReplyOptions";
import AcademyReplyVideo from "./AcademyReplyVideo";
import { SPIRE_ACADEMY } from "../../../utils/helpers/chatAssistants";
import { getAcademyReply, createAcademySelection, createAcademyVideoCompletion, getLatestAcademyMessageId } from "../../../utils/helpers/academyChat";
import { message as academyNotification } from "antd";
import { getChatAttachments } from "../../../utils/helpers/chatAttachments";
import { getChatMessageContent, getChatMessageHtml } from "../../../utils/helpers/chatMessageContent";
import { isAssistantRoom } from "../../../utils/helpers/chatAssistants";
import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  memo,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/styles/local/Chat.css";
import typingLoader from "../../../assets/icons/typingLoader.svg";
import ChatGPTGirl from "../../../assets/icons/ChatGPTGirl2.png";
import search from "../../../assets/images/search.svg";
import emojiIcon from "../../../assets/icons/smileSMS.svg";
import attachIcon from "../../../assets/icons/attach_fileSMS.svg";
import BoldIcon from "../../../assets/icons/Bold.svg";
import deleteIcon from "../../../assets/icons/Bin.svg";
import SearchNoResultSmileIcon from "../../../assets/icons/meh.svg";
import smsSendIcon from "../../../assets/icons/sendSMSIcon.svg";
import addGroupIcon from "../../../assets/icons/addgroupIcon.svg";
import chatBackIcon from "../../../assets/icons/chat Back.png";
import xCircle from "../../../assets/icons/x-circle.svg";
import ItalicIcon from "../../../assets/icons/italic.svg";
import UnderlineIcon from "../../../assets/icons/underline.svg";
import { BsArrowUpRightCircle, BsArrowDown } from "react-icons/bs";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { BiCheckDouble, BiCheck } from "react-icons/bi";
import { RiDeleteBin7Line } from "react-icons/ri";
import addGroupIconHover from "../../../assets/icons/addgroupiconHover.svg";
import simpleRequest from "../../../utils/helpers/simpleRequest";
import axios from "axios";
import {
  ADD_CONTACTS,
  ADD_TASK,
  ADD_USER_TO_GROUP_CHAT_WIDGET,
  API_URL,
  DELETE_CONVERSATION,
  GLOBAL_CHAT,
  UPDATE_CONTACTS,
  UPDATE_TASK,
  CHAT_CONVERSATION_GET,
} from "../../../redux/constants/type";
import {
  getChatConversations,
  loadMoreChatConversations,
  getChatRooms,
  UpdateConversation,
  SearchConversations,
  NewConversation,
  UpdateMessage,
  FetchUsersToGroup,
  AddGroups,
  GroupInfo,
  EmptyAddGroupState,
  DeleteMessage,
  createTaskChat,
  globalChat,
} from "../../../redux/actions/chatActions";
import {
  EmptyProductPart,
  FetchRoleModuleAccess,
  RemoveDocsClientById,
} from "../../../redux/actions/action";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { CHAT_API_URL } from "../../../redux/constants/type";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import moment from "moment";
import { getLocalFormatedTime } from "../../../utils/helpers/calculateTime";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../../layouts/Header";
import { AiOutlinePlus } from "react-icons/ai";
import { BsX } from "react-icons/bs";
import chatSearchIcon from "../../../assets/icons/chatsearchIcon.svg";
import smileChatIcon from "../../../assets/icons/smileChatIcon.svg";
import { Image } from "react-bootstrap";
import {
  handleGeneralNotification,
  ShowUndoNotification,
} from "../../../utils/helpers/notifications";
import { axiosInstance } from "../../../redux/constants/axiosInstance";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  Modifier,
  ContentState,
  SelectionState,
  convertToRaw,
  RichUtils,
  getDefaultKeyBinding,
} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
import useDebounce from "../../../utils/hooks/useDebounceHook";
import ReactVisibilitySensor from "react-visibility-sensor";
import DocumentUploaderWithProgress from "../../Common/Document_Uploader_With_Progress";
import roundFileSize from "../../../utils/Documents/roundFileSize";
import {
  ArchiveBlackOutlineIcon,
  BackArchiveOutlineIcon,
} from "../../../assets/svgs/SvgsImg";
import TaskDelete from "../../Dailogs/TaskDelete";
import useScreenSize from "../../../utils/hooks/useScreenSizeHook";
import { v4 as uuidv4 } from "uuid";
import RoomListWrapper from "./RoomListWrapper";
import RoomListWrapperMember from "./RoomListWrapperMember";
import ArchiveChatOptions from "./ArchiveChatOptions";
import MemberInfoDetail from "./MemberInfoDetail";
import GroupInfoDetail from "./GroupInfoDetail";
import SearchConversation from "./SearchConversation";
import AddMemberToGroup from "./AddMemberToGroup";
import NoResults from "./NoResults";
import DocumentAttachedModal from "./DocumentAttachedModal";
import GroupChatAction from "././GroupChatAction";
import Linkify from "react-linkify";
import LinkifyIt from "linkify-it";
import Loader from "../../Dailogs/Loader";

const isStatusTrue = (value) => {
  if (value === true) return true;
  if (typeof value === "number") return value > 0;
  if (typeof value === "string") {
    const normalizedValue = value.trim().toLowerCase();
    return ["true", "1", "yes", "y"].includes(normalizedValue);
  }
  return false;
};

const isStatusText = (value, statuses) =>
  typeof value === "string" && statuses.includes(value.trim().toLowerCase());

// ChatGPT and Google often wrap text inside each list item with <p> or <div>.
// Without flattening that wrapper, html-to-draftjs creates an empty list marker
// followed by a separate paragraph instead of a single bullet item.

const normalizePastedListHtml = (html = "") => {
  const doc = new DOMParser().parseFromString(html, "text/html");

  // Remove empty paragraphs/divs inside list items
  doc.querySelectorAll("li").forEach((li) => {
    li.querySelectorAll("p, div").forEach((element) => {
      element.replaceWith(...Array.from(element.childNodes));
    });
  });

  return doc.body.innerHTML;
};

const getMessageId = (message) => {
  if (typeof message === "string" || typeof message === "number") {
    return message;
  }

  return (
    message?.messageid ??
    message?.messageId ??
    message?.MessageId ??
    message?.id
  );
};

const getMessageSenderId = (message) =>
  message?.senderid ??
  message?.senderId ??
  message?.SenderId ??
  message?.userid ??
  message?.userId ??
  message?.UserId;

const getMessageGroupId = (message) =>
  message?.groupid ?? message?.groupId ?? message?.GroupId;

const areSameId = (firstId, secondId) =>
  firstId?.toString()?.toLowerCase() === secondId?.toString()?.toLowerCase();

const getReadStatus = (message) =>
  message?.isReadByAll ??
  message?.isreadbyall ??
  message?.IsReadByAll ??
  message?.readByAll ??
  message?.ReadByAll ??
  message?.isRead ??
  message?.isread ??
  message?.IsRead;

const getDeliveredStatus = (message) =>
  message?.isreceiverreadonly ??
  message?.isReceiverReadOnly ??
  message?.isReceiverReadonly ??
  message?.IsReceiverReadOnly ??
  message?.IsReceiverReadonly;

const getMessageStatus = (message) =>
  message?.status ??
  message?.Status ??
  message?.messageStatus ??
  message?.MessageStatus;

const isMessageRead = (message) =>
  isStatusTrue(getReadStatus(message)) ||
  isStatusText(getMessageStatus(message), ["read", "seen"]);

const isMessageDelivered = (message) =>
  isStatusTrue(getDeliveredStatus(message));

const ChatWidget = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const containerRef = useRef(null);
  const emojiElementRef = useRef(null);
  const userTypingTimerRef = useRef(null);
  let hiddenFileInput = useRef(null);
  const urlSearch = useLocation().search;
  const searchParams = new URLSearchParams(urlSearch);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );
  const [typing, setTyping] = useState(false);
  const [aiTyping, setAiTyping] = useState(false);
  const [isUserTyping, setIsUserTyping] = useState(false);

  const chatRooms = useSelector((state) => state.chat.chatRooms);
  const AddGroupsRes = useSelector((state) => state.chat.AddGroups);
  const UserLeaveGroup = useSelector((state) => state.chat.UserLeaveGroup);

  const FetchUsersToGroupData = useSelector(
    (state) => state.chat.FetchUsersToGroup,
  );
  const isChatRoomLoading = useSelector((state) => state.chat.chatRoomLoading);
  const chatConversations = useSelector((state) => state.chat.chatHistory);
  const addGroupsResponse = useSelector(
    (state) => state.chat.addGroupsResponse,
  );
  const globalChatData = useSelector((state) => state.chat.globalChatData);
  const GroupInfoReq = useSelector((state) => state.chat.GroupInfo);
  const UpdateGroupInfoRes = useSelector((state) => state.chat.UpdateGroupInfo);

  const OnDeleteConversation = useSelector(
    (state) => state.chat.DeletedConversation,
  );
  const searchConversationsResponse = useSelector(
    (state) => state.chat.searchConversationsResponse,
  );
  const chatDeleteMessageRes = useSelector(
    (state) => state.chat.chatDeleteMessageRes,
  );
  const hasMoreMessages = useSelector((state) => state.chat.hasMoreMessages);
  const AddUserToGroupReq = useSelector((state) => state.chat.AddUserToGroup);
  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);
  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse,
  );
  const addContactResponse = useSelector((state) => state.user.AddContacts);
  const updateContactResponse = useSelector(
    (state) => state.user.UpdateContactsdata,
  );

  const selectedRoomRef = useRef(null);
  const readReceiptsSentRef = useRef(new Set());
  const [showDownArrow, setShowDownArrow] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [connection, setConnection] = useState(null);
  const [academyOptionPending, setAcademyOptionPending] = useState(false);
  const academyOptionPendingRef = useRef(false);
  const [searchText, setSearchText] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchedData, setSearchedData] = useState({});
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const currentUserId = window.localStorage.getItem("userid");
  const selectedGroupId = window.localStorage.getItem("selectedGroupId");
  const currentUserName = window.localStorage.getItem("firstname");
  const currentUserLastName = window.localStorage.getItem("lastname");
  const [groupedChatConversations, setGroupedChatConversations] = useState([]);
  const messageStatusRef = useRef({});
  const [createGroupStat, setCreateGroupStat] = useState(false);
  const [showAction, setShowAction] = useState(false);
  const [addGroupHover, setAddGroupHover] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [rightSideMenuStat, setRightSideMenuStat] = useState(false);
  const [searchStat, setSearchStat] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupMember, setGroupMember] = useState([]);
  const [addGroupMemberSearch, setAddGroupMemberSearch] = useState("");
  const [searchConversation, setSearchConversation] = useState(false);
  const [memberInfoDetail, setMemberInfoDetail] = useState(false);
  const [groupInfoDetail, setGroupInfoDetail] = useState(false);
  const [selectedCurrentRoomGroupId, setSelectedCurrentRoomGroupId] =
    useState("");
  const [coworkerDetails, setCoworkerDetails] = useState({});
  const [groupDetails, setGroupDetails] = useState({});
  const [addMemberGroupList, setAddMemberGroupList] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalFunction, setModalFunction] = useState("add");
  const [taskId, setTaskId] = useState(
    window.localStorage.getItem("taskid") || "",
  );
  const [modelTypeId, setModelTypeId] = useState("");
  const [isConnectionStarted, setIsConnectionStarted] = useState(false);
  const [skip, setSkip] = useState(0);
  const isLoadingMoreRef = useRef(false);

  const [showAdminDrop, setShowAdminDrop] = useState(false);
  const [isAttached, setIsAttached] = useState(false);
  const [attachedName, setAttachedName] = useState();
  const [attachedSize, setAttachedSize] = useState();
  const roleId = window.localStorage.getItem("roleid");
  const [createAGroupchat, setCreateAGroupchat] = useState(false);
  const [showArchiveChats, setShowArchiveChats] = useState(false);
  const [isChatMessagesLoading, setIsChatMessagesLoading] = useState(false);
  const roleModuleData = useSelector(
    (state) => state.user.FetchRoleModuleAccess,
  );
  const currentCompanyId = useMemo(() =>
    window.localStorage.getItem("companyid"),
  );
  const [fetchTransChatList, setFetchTransChatList] = useState({});
  const t = (key) => fetchTransChatList?.[key] || "";
  const sendTypingState = (groupName, value) =>
    connection?.invoke("TypingStateChanged", groupName, value) || Promise.resolve();

  // const [isSending, setIsSending] = useState(false);

  const rememberMessageStatus = useCallback((messageId, status) => {
    const targetMessageId = messageId?.toString()?.toLowerCase();
    if (!targetMessageId) return;

    messageStatusRef.current[targetMessageId] = {
      ...(messageStatusRef.current[targetMessageId] || {}),
      ...status,
    };
  }, []);

  const applyRememberedMessageStatuses = useCallback((conversationGroups) => {
    return conversationGroups.map((dayGroup) => ({
      ...dayGroup,
      messages: dayGroup.messages?.map((message) => {
        const messageId = getMessageId(message)?.toString()?.toLowerCase();
        if (!messageId) return message;

        if (isMessageRead(message)) {
          const readStatus = getReadStatus(message) ?? true;
          const deliveredStatus = getDeliveredStatus(message) ?? true;
          messageStatusRef.current[messageId] = {
            ...(messageStatusRef.current[messageId] || {}),
            isReadByAll: readStatus,
            isreceiverreadonly: deliveredStatus,
            isReceiverReadOnly: deliveredStatus,
            isDelivered: deliveredStatus,
          };
        } else if (isMessageDelivered(message)) {
          const deliveredStatus = getDeliveredStatus(message) ?? true;
          messageStatusRef.current[messageId] = {
            ...(messageStatusRef.current[messageId] || {}),
            isreceiverreadonly: deliveredStatus,
            isReceiverReadOnly: deliveredStatus,
            isDelivered: deliveredStatus,
          };
        }

        const rememberedStatus = messageStatusRef.current[messageId];
        return rememberedStatus ? { ...message, ...rememberedStatus } : message;
      }),
    }));
  }, []);

  const updateLocalMessageStatus = useCallback(
    (messageId, status) => {
      const targetMessageId = messageId?.toString()?.toLowerCase();
      if (!targetMessageId) return;

      rememberMessageStatus(targetMessageId, status);

      setGroupedChatConversations((prev) =>
        prev.map((dayGroup) => ({
          ...dayGroup,
          messages: dayGroup.messages?.map((message) =>
            getMessageId(message)?.toString()?.toLowerCase() === targetMessageId
              ? { ...message, ...status }
              : message,
          ),
        })),
      );
    },
    [rememberMessageStatus],
  );

  const invokeMessageReadStatusChanged = useCallback(
    (groupId) => {
      if (!connection || !currentCompanyId || !groupId || !currentUserId) {
        console.log("asc200 Early return", {
          connection: !!connection,
          currentCompanyId,
          groupId,
          currentUserId,
        });
        return;
      }

      console.log("MessageReadStatusChanged invoke", {
        groupname: `${currentCompanyId}-${groupId}`,
        userid: currentUserId,
        groupid: groupId,
      });

      connection
        .invoke("MessageReadStatusChanged", `${currentCompanyId}-${groupId}`, {
          userid: currentUserId,
          groupid: groupId,
        })
        .then(() => {
          console.log("asc200 Invoke Success");
        })
        .catch((err) => {
          console.error("asc200 Invoke Error", err);
        });
    },
    [connection, currentCompanyId, currentUserId],
  );

  const invokeMessageDelivered = useCallback(
    (message) => {
      const groupId = getMessageGroupId(message);
      const messageId = getMessageId(message);
      const senderId = getMessageSenderId(message);

      if (
        !connection ||
        !currentCompanyId ||
        !groupId ||
        !messageId ||
        !currentUserId ||
        areSameId(senderId, currentUserId)
      ) {
        return;
      }

      connection
        .invoke(
          "MessageDelivered",
          `${currentCompanyId}-${groupId}`,
          messageId,
          currentUserId,
        )
        .catch((err) => console.error(err));
    },
    [connection, currentCompanyId, currentUserId],
  );

  const handleVisibleMessageRead = useCallback(
    (message) => {
      if (!message || isMessageRead(message)) return;

      const messageId = getMessageId(message);
      const groupId =
        getMessageGroupId(message) || selectedRoomRef.current?.groupid;
      const senderId = getMessageSenderId(message);

      if (
        !messageId ||
        !groupId ||
        !currentUserId ||
        areSameId(senderId, currentUserId) ||
        readReceiptsSentRef.current.has(messageId)
      ) {
        return;
      }

      readReceiptsSentRef.current.add(messageId);
      setTimeout(() => {
        invokeMessageReadStatusChanged(groupId);
      }, 800);
    },
    [currentUserId, invokeMessageReadStatusChanged],
  );

  useEffect(() => {
    selectedRoomRef.current = selectedRoom;
  }, [selectedRoom]);

  useEffect(() => {
    fetchScreenTranslations("Chat").then((res) => {
      setFetchTransChatList(res);
    });
  }, []);

  useEffect(() => {
    if (AddUserToGroupReq?.status === true) {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: AddUserToGroupReq.message || `User Added To Group Successfully`,
      });
      dispatch(GroupInfo(currentUserId, selectedRoom?.groupid));
      dispatch({
        type: ADD_USER_TO_GROUP_CHAT_WIDGET,
        data: {},
      });
    }
  }, [AddUserToGroupReq]);

  useEffect(() => {
    //clear old chat data when redirect from spire AI screen start
    const roomId = searchParams.get("room");
    if (roomId) {
      dispatch({ type: CHAT_CONVERSATION_GET });
    }
    // clear old chat data when redirect from spire AI screen end

    Object.defineProperty(WebSocket, "OPEN", { value: 1 });
    const newConnection = new HubConnectionBuilder()
      //TODO: Update API base url
      .withUrl(`${CHAT_API_URL}/chat`, {
        withCredentials: true,
        accessTokenFactory: () =>
          Promise.resolve(window.localStorage.getItem("token")),
      })
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
    //INFO: Need to change userid
    dispatch(getChatRooms(currentUserId));
    checkRoomRedirection();
  }, []);

  useEffect(() => {
    checkRoomRedirection();
  }, [searchParams]);

  useEffect(() => {
    dispatch(FetchRoleModuleAccess(roleId));
  }, []);

  useEffect(() => {
    if (UpdateGroupInfoRes.status === true) {
      setSearchText("");
      const room = {
        groupid: UpdateGroupInfoRes?.data?.groupid,
        groupname: UpdateGroupInfoRes?.data?.groupname,
        groupicon: UpdateGroupInfoRes?.data?.groupicon,
      };
      setSelectedRoom(room);
      dispatch(getChatRooms(currentUserId, "Creating Group"));
      dispatch(
        getChatConversations(
          UpdateGroupInfoRes?.data[0]?.groupid,
          currentUserId,
        ),
      );
      return;
    }
  }, [UpdateGroupInfoRes, chatDeleteMessageRes]);

  const checkRoomRedirection = () => {
    const roomId = searchParams.get("room");
    if (roomId && chatRooms) {
      const existingRoom = chatRooms.findIndex((x) => x.groupid == roomId);
      if (existingRoom != -1 && selectedRoom?.groupid !== roomId) {
        handleOnRoomSelect(chatRooms[existingRoom], true);
        // history.replace("/chat");
      }
    }
  };

  useEffect(() => {
    checkRoomRedirection();
  }, [chatRooms]);

  useEffect(() => {
    if (globalChatData.groupid) {
      setSelectedRoom(globalChatData);
    } else {
      // dispatch(addIndividualGroups(currentUserId, "", groupUser));
    }
  }, [globalChatData]);

  useEffect(() => {
    if (!connection) return;

    // Register listeners ONLY ONCE
    const handleReceiveMessage = (message) => {
      console.log("asc23");
      setAiTyping(false);

      let newMsg = {
        messageid: getMessageId(message),
        groupid: getMessageGroupId(message),
        senderid: getMessageSenderId(message),
        messages: message?.messagetext,
        time: new Date(),
        type: message?.type,
        attachments: message?.attachments,
        senderimage: message?.senderimage,
        senderfirstname: message?.senderfirstname,
        senderlastname: message?.senderlastname,
        isReadByAll: getReadStatus(message),
        isreceiverreadonly: getDeliveredStatus(message),
      };

      dispatch(UpdateConversation(newMsg));
      UpdateConversationList();

      invokeMessageDelivered(message);

      const activeRoom = selectedRoomRef.current;
      console.log("asc112 activeRoom", activeRoom);
      console.log("asc112 currentUserId", currentUserId);
      console.log("asc112 message.userid", getMessageSenderId(message));
      if (
        getMessageGroupId(message) &&
        areSameId(activeRoom?.groupid, getMessageGroupId(message)) &&
        !areSameId(getMessageSenderId(message), currentUserId)
      ) {
        handleVisibleMessageRead(message);
      }
    };

    connection.on("ReceiveMessage", handleReceiveMessage);

    const handleUserTyping = (typingPayload) => {
      const activeRoom = selectedRoomRef.current;
      const payloadIsObject =
        typingPayload !== null &&
        typeof typingPayload === "object" &&
        !Array.isArray(typingPayload);
      const typingUserId = payloadIsObject
        ? getMessageSenderId(typingPayload)
        : null;
      const typingGroupId = payloadIsObject
        ? getMessageGroupId(typingPayload)
        : null;
      const isTyping =
        payloadIsObject && typingPayload?.isTyping !== undefined
          ? typingPayload.isTyping
          : payloadIsObject && typingPayload?.typing !== undefined
            ? typingPayload.typing
            : payloadIsObject && typingPayload?.IsTyping !== undefined
              ? typingPayload.IsTyping
              : payloadIsObject && typingPayload?.Typing !== undefined
                ? typingPayload.Typing
                : typingPayload;

      if (typingGroupId && !areSameId(typingGroupId, activeRoom?.groupid)) {
        return;
      }

      if (typingUserId && areSameId(typingUserId, currentUserId)) {
        return;
      }

      const nextTypingState = isStatusTrue(isTyping);
      setIsUserTyping(nextTypingState);

      if (userTypingTimerRef.current) {
        clearTimeout(userTypingTimerRef.current);
      }

      if (nextTypingState) {
        userTypingTimerRef.current = setTimeout(() => {
          setIsUserTyping(false);
        }, 2500);
      }
    };

    connection.on("IsUserTyping", handleUserTyping);

    const getStatusItems = (data) => {
      if (Array.isArray(data?.messages)) return data.messages;
      if (Array.isArray(data?.messageIds)) return data.messageIds;
      if (Array.isArray(data?.messageids)) return data.messageids;
      if (Array.isArray(data?.MessageIds)) return data.MessageIds;
      if (Array.isArray(data)) return data;
      if (getMessageId(data)) return [data];
      return [];
    };

    const handleReadStatusUpdate = (data) => {
      const readMessages = getStatusItems(data);

      readMessages.forEach((item) => {
        const messageId = getMessageId(item);
        if (!messageId) return;

        const readStatus = getReadStatus(item) ?? true;
        const deliveredStatus = getDeliveredStatus(item) ?? true;

        updateLocalMessageStatus(messageId, {
          isReadByAll: readStatus,
          isreceiverreadonly: deliveredStatus,
          isReceiverReadOnly: deliveredStatus,
          isDelivered: deliveredStatus,
        });
      });
    };

    const handleDeliveredStatusUpdate = (data) => {
      const deliveredMessages = getStatusItems(data);

      deliveredMessages.forEach((item) => {
        const messageId = getMessageId(item);
        if (!messageId) return;

        const deliveredStatus = getDeliveredStatus(item) ?? true;

        updateLocalMessageStatus(messageId, {
          isreceiverreadonly: deliveredStatus,
          isReceiverReadOnly: deliveredStatus,
          isDelivered: deliveredStatus,
        });
      });
    };

    const readStatusEvents = [
      "message-read-status-update",
      "MessageReadStatusUpdate",
      "messageReadStatusUpdate",
    ];
    const deliveredStatusEvents = [
      "message-delivered-status-update",
      "MessageDeliveredStatusUpdate",
      "messageDeliveredStatusUpdate",
    ];

    readStatusEvents.forEach((eventName) =>
      connection.on(eventName, handleReadStatusUpdate),
    );
    deliveredStatusEvents.forEach((eventName) =>
      connection.on(eventName, handleDeliveredStatusUpdate),
    );

    connection.on("NewConversation", (userids) => {
      if (userids?.indexOf(currentUserId) > -1) {
        UpdateConversationList();
      }
    });

    connection.on("NewConversationSuccess", (roomDetail) => {
      UpdateConversationList();
      let roomObj = roomDetail[0];
      roomObj.groupicon = roomDetail[1][0].imageurl;
      roomObj.groupname = roomDetail[1][0].username;
      handleOnRoomSelect(roomDetail[0]);
    });

    connection.on("NewConversationList", (conversationList) => {
      dispatch(NewConversation(conversationList));
    });

    connection.on("ForceUpdateConversationList", () => {
      UpdateConversationList();
    });

    // Start connection separately
    connection
      .start()
      .then(() => setIsConnectionStarted(true))
      .catch((e) => console.error("Connection failed:", e));

    // CLEANUP
    return () => {
      connection.off("ReceiveMessage", handleReceiveMessage);
      connection.off("NewConversation");
      connection.off("NewConversationSuccess");
      connection.off("NewConversationList");
      connection.off("ForceUpdateConversationList");
      connection.off("IsUserTyping", handleUserTyping);
      if (userTypingTimerRef.current) {
        clearTimeout(userTypingTimerRef.current);
      }
      readStatusEvents.forEach((eventName) =>
        connection.off(eventName, handleReadStatusUpdate),
      );
      deliveredStatusEvents.forEach((eventName) =>
        connection.off(eventName, handleDeliveredStatusUpdate),
      );
    };
  }, [
    connection,
    currentUserId,
    handleVisibleMessageRead,
    invokeMessageDelivered,
    invokeMessageReadStatusChanged,
    updateLocalMessageStatus,
  ]);

  //UPDATE:07
  const UpdateConversationList = () => {
    connection
      .invoke("ConversationList", { userid: currentUserId })
      .then(() => {})
      .catch((err) => console.error(err));
  };

  const changeApplied_old = (e) => {
    setEditorState(e);
    setTyping(true);
    setTaggedUser(extractTaggedUserIds(e));
  };

  const extractTaggedUserIds = (currentEditorState) => {
    const textMessage = convertToRaw(currentEditorState.getCurrentContent());

    if (
      !textMessage?.entityMap ||
      Object.keys(textMessage.entityMap).length === 0
    ) {
      return [];
    }

    const ids = Object.values(textMessage.entityMap)
      .filter(
        (item) =>
          item?.type?.toLowerCase() === "mention" &&
          item?.data?.url !== null &&
          item?.data?.url !== undefined,
      )
      .map((item) => item.data.url);

    return [...new Set(ids)];
  };

  const typingTimer = useRef(null);



  const changeApplied = async (e) => {
    const content = e.getCurrentContent();
    const blocks = content.getBlocksAsArray();
    const contentWithoutEmptyListBlocks = blocks.reduce(
      (updatedContent, block) => {
        const isEmptyListBlock =
          !block.getText().trim() && /-list-item$/.test(block.getType());

        return isEmptyListBlock
          ? Modifier.setBlockType(
              updatedContent,
              SelectionState.createEmpty(block.getKey()),
              "unstyled",
            )
          : updatedContent;
      },
      content,
    );
    const nextEditorState =
      contentWithoutEmptyListBlocks !== content
        ? EditorState.push(
            e,
            contentWithoutEmptyListBlocks,
            "change-block-type",
          )
        : e;

    setEditorState(nextEditorState);

    if (!connection || !selectedRoom?.groupid || !currentCompanyId) {
      return;
    }

    if (!typing) {
      setTyping(true);

      sendTypingState(`${currentCompanyId}-${selectedRoom.groupid}`, true)
        .catch((err) => console.error(err));
    }

    clearTimeout(typingTimer.current);

    typingTimer.current = setTimeout(async () => {
      setTyping(false);

      sendTypingState(`${currentCompanyId}-${selectedRoom.groupid}`, false)
        .catch((err) => console.error(err));
    }, 1500);
  };

  const handlePastedText = (text, html, currentEditorState) => {
    if (!html) return "not-handled";

    const pastedBlocks = htmlToDraft(normalizePastedListHtml(html));
    const pastedContent = ContentState.createFromBlockArray(
      pastedBlocks.contentBlocks,
      pastedBlocks.entityMap,
    );
    const contentWithPaste = Modifier.replaceWithFragment(
      currentEditorState.getCurrentContent(),
      currentEditorState.getSelection(),
      pastedContent.getBlockMap(),
    );
    const nextEditorState = EditorState.push(
      currentEditorState,
      contentWithPaste,
      "insert-fragment",
    );

    changeApplied(nextEditorState);
    return "handled";
  };

  const handleDraftState = async () => {
    if (!selectedRoom?.groupid) return;
    const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
    const textMessage = convertToRaw(newState.getCurrentContent());
    let messageId = uuidv4();
    let draftMessage;
    for (let i = 0; i < groupedChatConversations.length; i++) {
      draftMessage = groupedChatConversations?.[i]?.messages?.find(
        (item2) => item2.isdraft && !item2.isdeleted,
      );
      if (draftMessage) break;
    }
    if (textMessage?.blocks[0]?.text?.length) {
      const chatMessage = {
        messageid: messageId,
        groupid: selectedRoom.groupid,
        //INFO: Need to change userid
        userid: currentUserId,
        messagetext: JSON.stringify(textMessage),
        attachments: JSON.stringify(attachmentUrl),
        type: selectedRoom.type,
        senderimage: window.localStorage.getItem("userimageurl"),
        senderfirstname: window.localStorage.getItem("firstname"),
        senderlastname: window.localStorage.getItem("lastname"),
        isdraft: 1,
      };
      draftMessage &&
        (await simpleRequest(`/api/Chatting/DeleteMessage`, "post", {
          messageid: draftMessage?.messageid,
        }));
      await connection
        .invoke(
          "SendMessage",
          `${currentCompanyId}-${selectedRoom.groupid}`,
          chatMessage,
        )
        .catch((err) => console.error(err));
    } else {
      draftMessage &&
        (await simpleRequest(`/api/Chatting/DeleteMessage`, "post", {
          messageid: draftMessage?.messageid,
        }));
    }
  };

  const shouldRestoreDraftRef = useRef(false);

  useEffect(() => {
    setEditorState(EditorState.createEmpty());
    shouldRestoreDraftRef.current = true;
  }, [selectedRoom?.groupid]);

  useEffect(() => {
    if (isChatMessagesLoading) return;
    if (!shouldRestoreDraftRef.current) return;
    if (!groupedChatConversations?.length) return;

    shouldRestoreDraftRef.current = false;

    let draftMessage;
    for (let i = 0; i < groupedChatConversations.length; i++) {
      draftMessage = groupedChatConversations?.[i]?.messages?.find(
        (item2) => item2.isdraft && !item2.isdeleted,
      );
      if (draftMessage) break;
    }

    if (draftMessage && draftMessage.senderid === currentUserId) {
      const contentState = getChatMessageContent(draftMessage.messages);
      setEditorState(
        EditorState.moveFocusToEnd(EditorState.createWithContent(contentState)),
      );
    }
  }, [groupedChatConversations, isChatMessagesLoading]);

  const handleOnRoomSelect = async (room, fromUrl = false) => {
    setIsChatMessagesLoading(true);
    if (searchText || searchPeople) {
      if (room?.groupid === null) {
        const groupUser = [
          { groupmember: room?.userid },
          { groupmember: currentUserId },
        ];
        if (selectedRoom) {
          connection
            .invoke("LeaveGroup", `${currentCompanyId}-${selectedRoom.groupid}`)
            .then(() => {})
            .catch((err) => console.error(err));
          sendTypingState(`${currentCompanyId}-${selectedRoom?.groupid}`, false)
            .catch((err) => console.error(err));
        }
        setSearchText("");
        await connection
          .invoke("NewConversationInitiate", {
            userid: currentUserId,
            groupdescription: "",
            groupuser: groupUser,
          })
          .catch((err) => console.error(err));
      } else {
        if (selectedRoom) {
          connection
            .invoke("LeaveGroup", `${currentCompanyId}-${selectedRoom.groupid}`)
            .then(() => {})
            .catch((err) => console.error(err));
          sendTypingState(`${currentCompanyId}-${selectedRoom?.groupid}`, false)
            .catch((err) => console.error(err));
        }
        setSelectedRoom(room);
        if (!fromUrl) {
          history.replace(`/chat?room=${room.groupid}`);
        }
        setSearchText("");
      }
    } else {
      if (selectedRoom) {
        handleDraftState();
        connection
          .invoke("LeaveGroup", `${currentCompanyId}-${selectedRoom.groupid}`)
          .then(() => {})
          .catch((err) => console.error(err));
        sendTypingState(`${currentCompanyId}-${selectedRoom?.groupid}`, false)
          .catch((err) => console.error(err));
      }
      setSelectedRoom(room);
      if (!fromUrl) {
        history.replace(`/chat?room=${room.groupid}`);
      }
      setSearchText("");
    }
    if (room.groupid) {
      dispatch(UpdateMessage(currentUserId, room.groupid));
    }
    setTimeout(() => {
      // if (searchText) {
      //   setSearchLoading(true);
      //   dispatch(SearchConversations(searchText, currentUserId));
      // } else {
      //   return;
      // }
      dispatch(getChatRooms(currentUserId));
    }, 1000);
    setVal("");
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleDraftState);
    return () => {
      window.removeEventListener("beforeunload", handleDraftState);
    };
  }, [
    editorState,
    selectedRoom,
    groupedChatConversations,
    connection,
    attachmentUrl,
    currentCompanyId,
  ]);

  useEffect(() => {
    if (selectedRoom && isConnectionStarted) {
      connection
        .invoke("JoinGroup", `${currentCompanyId}-${selectedRoom.groupid}`)
        .then(() => {
          invokeMessageReadStatusChanged(selectedRoom.groupid);
        })
        .catch((err) => console.error(err));
      sendTypingState(`${currentCompanyId}-${selectedRoom?.groupid}`, false)
        .catch((err) => console.error(err));
      //INFO: Need to change userid
      setSkip(0);
      isLoadingMoreRef.current = false;
      dispatch(
        getChatConversations(selectedRoom.groupid, currentUserId, 0, 10),
      );
      dispatch(GroupInfo(currentUserId, selectedRoom.groupid));
      setTyping(false);
    }
  }, [
    selectedRoom,
    chatDeleteMessageRes,
    isConnectionStarted,
    invokeMessageReadStatusChanged,
  ]);

  useEffect(() => {
    if (groupedChatConversations && groupedChatConversations.length > 0) {
      setIsChatMessagesLoading(false);
    }
  }, [groupedChatConversations]);

  // old
  // useEffect(() => {
  //   if (!connection) return;
  //   if (connection.state === "Connected") {
  //     connection
  //       .invoke("TypingStateChanged", `null-${selectedRoom?.groupid}`, typing)
  //       .catch((err) => console.error(err));
  //   }
  // }, [typing, connection]);

  useEffect(() => {
    const addContactData = async () => {
      if (addContactResponse?.status === 200) {
        const room = {
          groupid: selectedGroupId,
          groupname: globalChatData?.groupname,
          groupicon: globalChatData?.groupicon,
          primarycolor: globalChatData?.primarycolor,
          type: "Group",
        };
        dispatch(getChatConversations(selectedGroupId, currentUserId));
        setSelectedRoom(room);
        resetEditorState();
      }
    };

    const resetEditorState = () => {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: addContactResponse.message || "Contact Added Successfully",
      });
      if (textAreaRef.current) textAreaRef.current.value = "";
      setVal("");
      setTyping(false);
      setEditorState(EditorState.moveFocusToEnd(EditorState.createEmpty()));
      setAttachmentUrl("");
      setIsAttached(false);
      setTaskId("");
      dispatch({ type: ADD_CONTACTS, data: {} });
      dispatch({ type: GLOBAL_CHAT, data: {} });
      scrollToBottom();
      window.localStorage.removeItem("selectedGroupId");
    };
    addContactData();
  }, [addContactResponse, connection]);

  useEffect(() => {
    if (updateContactResponse?.status) {
      dispatch({ type: UPDATE_CONTACTS, data: {} });
      setTaskId("");
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: updateContactResponse.message || "Update Contact Successfully",
      });
      scrollToBottom();
      window.localStorage.removeItem("selectedGroupId");
    }
    if (selectedGroupId) {
      const room = {
        groupid: selectedGroupId,
        groupname: globalChatData?.groupname,
        groupicon: globalChatData?.groupicon,
        primarycolor: globalChatData?.primarycolor,
        type: "Group",
      };
      dispatch(getChatConversations(selectedGroupId, currentUserId));
    }
    // setSelectedRoom(room); comment it Bcz chat will not work from Team Connect.
  }, [updateContactResponse]);

  useEffect(() => {
    const addTaskData = async () => {
      if (addTaskResponse?.status === true) {
        handleTaskSuccess();
        await sendTaskMessage();
        await dispatch(
          getChatConversations(selectedRoom?.groupid, currentUserId),
        );
        resetEditorState();
      }
    };

    const handleTaskSuccess = () => {
      setModelTypeId("");
      const newTaskId = addTaskResponse.data.taskid;
      const payload = {
        groupid: selectedRoom?.groupid,
        relatedtoid: newTaskId,
      };
      dispatch(createTaskChat(payload));
      setTaskId(newTaskId);
    };

    const sendTaskMessage = async () => {
      if (!selectedRoom?.groupid) return;

      const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
      const textMessage = convertToRaw(newState.getCurrentContent());
      const messageId = uuidv4();
      const chatMessage = createChatMessage(textMessage, messageId);

      await connection
        .invoke(
          "SendMessage",
          `${currentCompanyId}-${selectedRoom?.groupid}`,
          chatMessage,
        )
        .catch((err) => console.error(err));

      scrollToBottom();
    };

    const createChatMessage = (textMessage, messageId) => ({
      messageid: messageId,
      groupid: selectedRoom?.groupid,
      userid: currentUserId,
      messagetext: JSON.stringify(textMessage),
      attachments: attachmentUrl,
      type: "Group",
      senderimage: window.localStorage.getItem("userimageurl"),
      senderfirstname: window.localStorage.getItem("firstname"),
      senderlastname: window.localStorage.getItem("lastname"),
      taskid: addTaskResponse.data.taskid ?? "",
    });

    const resetEditorState = () => {
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: addTaskResponse.message || "Task Added Successfully",
      });
      window.localStorage.removeItem("taskid");
      if (textAreaRef.current) textAreaRef.current.value = "";
      setVal("");
      setTyping(false);
      setEditorState(EditorState.moveFocusToEnd(EditorState.createEmpty()));
      setAttachmentUrl("");
      setIsAttached(false);
      setTaskId("");
      dispatch({ type: ADD_TASK, data: {} });
    };

    addTaskData();
  }, [addTaskResponse]);

  useEffect(() => {
    if (updateTaskResponse?.status) {
      dispatch(getChatConversations(selectedRoom?.groupid, currentUserId));
      dispatch({ type: UPDATE_TASK, data: {} });
      setTaskId("");
      handleGeneralNotification({
        notificationType: "CUSTOM",
        text: updateTaskResponse.message || "Update Task Successfully",
      });
    }
  }, [updateTaskResponse]);

  const sendMessage = async () => {
    const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
    if (!selectedRoom?.groupid) {
      return;
    }
    const textMessage = convertToRaw(newState.getCurrentContent());
    const isEmptyMessage = textMessage.blocks[0].text.trim() === "";
    if (!isEmptyMessage || attachmentUrl) {
      let messgaeId = uuidv4();
      const taggedUserIds = extractTaggedUserIds(newState);
      setVal("");
      setTyping(false);
      setEditorState(EditorState.moveFocusToEnd(EditorState.createEmpty()));
      setAttachmentUrl("");
      setIsAttached(false);
      const time = new Date().toISOString().split(".")[0];
      const chatMessage = {
        messageid: messgaeId,
        groupid: selectedRoom.groupid,
        //INFO: Need to change userid
        userid: currentUserId,
        messagetext: JSON.stringify(textMessage),
        attachments: JSON.stringify(attachmentUrl),
        type: selectedRoom.type,
        senderimage: window.localStorage.getItem("userimageurl"),
        senderfirstname: window.localStorage.getItem("firstname"),
        senderlastname: window.localStorage.getItem("lastname"),
        taggedUser: taggedUserIds,
      };
      let newMsg = {
        messageid: messgaeId,
        senderid: chatMessage.userid,
        messages: chatMessage.messagetext,
        time: time,
        attachments: JSON.stringify(attachmentUrl),
        type: chatMessage.type,
        senderimage: window.localStorage.getItem("userimageurl"),
        senderfirstname: window.localStorage.getItem("firstname"),
        senderlastname: window.localStorage.getItem("lastname"),
      };
      let draftMessage;
      for (let i = 0; i < groupedChatConversations.length; i++) {
        draftMessage = groupedChatConversations?.[i]?.messages?.find(
          (item2) => item2.isdraft && !item2.isdeleted,
        );
        if (draftMessage) break;
      }
      if (draftMessage) {
        await simpleRequest(`/api/Chatting/DeleteMessage`, "post", {
          messageid: draftMessage?.messageid,
        });
      }
      if (navigator.onLine) {
        dispatch(UpdateConversation(newMsg));
      } else {
        dispatch(UpdateConversation(newMsg, "offline"));
        if (textAreaRef.current) textAreaRef.current.value = "";
        setVal("");
        setTyping(false);
        setEditorState(EditorState.moveFocusToEnd(EditorState.createEmpty()));
        return;
      }

      const assistantRoom = chatRooms.find(
        (room) => room.groupid === selectedRoom.groupid,
      ) || selectedRoom;
      if (isAssistantRoom(assistantRoom, coworkerDetails?.groupuser?.userid)) {
        setAiTyping(true);
      }

      if (textAreaRef.current) textAreaRef.current.value = "";
      try {
        await connection.invoke(
          "SendMessage",
          `${currentCompanyId}-${selectedRoom.groupid}`,
          chatMessage,
        );

        updateLocalMessageStatus(messgaeId, {
          isreceiverreadonly: 1,
          isReceiverReadOnly: 1,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setAiTyping(false);
      }

      await sendTypingState(`${currentCompanyId}-${selectedRoom.groupid}`, false)
        .catch((err) => console.error(err));

      scrollToBottom();
    }
  };
  const sendAcademyEvent = async (eventData, label) => {
    if (academyOptionPendingRef.current || !selectedRoom?.groupid) return false;
    if (!navigator.onLine || connection?.state !== "Connected") {
      academyNotification.error("Chat is disconnected. Please reconnect and try again.");
      return false;
    }
    academyOptionPendingRef.current = true;
    setAcademyOptionPending(true);
    setAiTyping(true);
    const groupId = selectedRoom.groupid;
    const messageId = uuidv4();
    const time = new Date().toISOString();
    const outgoing = {
      messageid: messageId,
      groupid: groupId,
      userid: currentUserId,
      messagetext: JSON.stringify(convertToRaw(ContentState.createFromText(label))),
      attachments: "[]",
      type: selectedRoom.type || "Individual",
      senderimage: window.localStorage.getItem("userimageurl"),
      senderfirstname: window.localStorage.getItem("firstname"),
      senderlastname: window.localStorage.getItem("lastname"),
      ...eventData,
    };
    try {
      dispatch(UpdateConversation({
        ...outgoing,
        senderid: currentUserId,
        messages: outgoing.messagetext,
        time,
      }));
      scrollToBottom();
      await connection.invoke("SendMessage", `${currentCompanyId}-${groupId}`, outgoing);
      if (eventData.academyStart) dispatch(getChatRooms(currentUserId));
      return true;
    } catch (error) {
      console.error("Unable to send Academy event:", error);
      if (eventData.academyStart) dispatch(getChatRooms(currentUserId));
      if (selectedRoomRef.current?.groupid === groupId) {
        dispatch(getChatConversations(groupId, currentUserId));
      }
      academyNotification.error("Unable to send the Academy update. Please try again.");
      return false;
    } finally {
      academyOptionPendingRef.current = false;
      setAcademyOptionPending(false);
      if (selectedRoomRef.current?.groupid === groupId) setAiTyping(false);
    }
  };

  const sendAcademyOption = (option, reply, sourceMessageId) => sendAcademyEvent({
    academySelection: createAcademySelection(option, reply, sourceMessageId),
  }, option.label);

  const sendAcademyVideoCompletion = (reply, sourceMessageId) => {
    const completed = createAcademyVideoCompletion(reply, sourceMessageId);
    if (!completed) return Promise.resolve(false);
    return sendAcademyEvent({ academyVideoCompletion: completed }, `Completed video ${completed.videoNumber}`);
  };

  // const resendMessage = async (message, messageItem) => {
  //   const time = new Date().toISOString().split(".")[0];
  //   let messgaeId = uuidv4();
  //   const chatMessage = {
  //     messageid: messgaeId,
  //     groupid: selectedRoom.groupid,
  //     //INFO: Need to change userid
  //     userid: currentUserId,
  //     messagetext: message,
  //     attachments: attachmentUrl,
  //     type: selectedRoom.type,
  //     senderimage: window.localStorage.getItem("userimageurl"),
  //     senderfirstname: window.localStorage.getItem("firstname"),
  //     senderlastname: window.localStorage.getItem("lastname"),
  //   };
  //   let newMsg = {
  //     messageid: messgaeId,
  //     senderid: chatMessage.userid,
  //     messages: message,
  //     time: time,
  //     attachments: attachmentUrl,
  //     type: chatMessage.type,
  //     senderimage: window.localStorage.getItem("userimageurl"),
  //     senderfirstname: window.localStorage.getItem("firstname"),
  //     senderlastname: window.localStorage.getItem("lastname"),
  //   };
  //   if (navigator.onLine) {
  //     handleMessageDelete(messageItem);
  //     await connection
  //       .invoke("SendMessage", `${currentCompanyId}-${selectedRoom.groupid}`, chatMessage)
  //       .catch((err) => console.error(err));
  //     dispatch(UpdateConversation(newMsg));
  //   } else {
  //     dispatch(UpdateConversation(newMsg, "offline"));
  //     return;
  //   }
  // };

  const [primaryColor, setPrimaryColor] = useState(
    window.localStorage.getItem("primarycolor"),
  );
  const [val, setVal] = useState("");
  const textAreaRef = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const resizeTextArea = () => {
    if (!textAreaRef.current) return;
    textAreaRef.current.style.height = "auto";
    textAreaRef.current.style.height = textAreaRef.current.scrollHeight + "px";
  };

  useEffect(resizeTextArea, [val]);

  useEffect(() => {
    if (Object.keys(OnDeleteConversation).length > 0) {
      dispatch(getChatRooms(currentUserId));
      if (
        selectedRoom != null &&
        selectedRoom.groupid == OnDeleteConversation.groupid
      ) {
        handleOnRoomSelect(OnDeleteConversation);
        setSelectedRoom(null);
      }
      dispatch({ type: DELETE_CONVERSATION, data: {} });
    }
  }, [OnDeleteConversation]);

  const scrollToBottom = () => {
    if (containerRef && containerRef.current) {
      const element = containerRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  useDebounce(
    () => {
      const term = searchText.trim();
      if (term.length) {
        setSearchLoading(true);
        dispatch(SearchConversations(term, currentUserId));
      } else {
        setSearchLoading(false);
      }
    },
    [searchText, currentUserId, dispatch],
    800,
  );

  useEffect(() => {
    if (searchConversationsResponse.status === true) {
      setSearchLoading(false);
      setSearchedData(searchConversationsResponse?.data);
    } else {
      setSearchLoading(false);
    }
  }, [searchConversationsResponse]);
  const [chatConversationsType, setChatConversationsType] = useState("");

  useEffect(() => {
    if (chatConversations) {
      setChatConversationsType(chatConversations[0]?.messages[0]?.type);
      return setGroupedChatConversations(
        applyRememberedMessageStatuses(chatConversations),
      );
    } else {
      setGroupedChatConversations((prev) =>
        applyRememberedMessageStatuses(prev),
      );
    }
  }, [chatConversations, applyRememberedMessageStatuses]);

  useEffect(() => {
    if (addGroupsResponse.status === true) {
      setSearchText("");
      const room = {
        groupid: addGroupsResponse?.data[0]?.groupid,
        groupname: addGroupsResponse?.data[1][0].username,
        assistantuserid: addGroupsResponse?.data[1][0].userid === SPIRE_ACADEMY.userId ? SPIRE_ACADEMY.userId : undefined,
        academystarted: addGroupsResponse?.data[1][0].userid === SPIRE_ACADEMY.userId ? false : undefined,
        groupicon: addGroupsResponse?.data[1][0].imageurl,
        primarycolor: addGroupsResponse?.data[1][0].primarycolor,
      };
      setSelectedRoom(room);
      dispatch(getChatRooms(currentUserId, "Creating Group"));
      dispatch(
        getChatConversations(
          addGroupsResponse?.data[0]?.groupid,
          currentUserId,
        ),
      );
      dispatch(
        UpdateMessage(currentUserId, addGroupsResponse?.data[0]?.groupid),
      );
      return;
    }
  }, [addGroupsResponse, chatDeleteMessageRes]);

  const onFileUploaded = (data) => {
    setIsAttached(true);
    const name = data?.map((item) => item?.name);
    const size = data?.map((item) => roundFileSize(item?.size));
    const link = data?.map((item) => item?.link);
    setAttachedName(name);
    setAttachedSize(size);
    setAttachmentUrl(link);
  };

  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  const handleMessageDelete = useCallback(
    (msg) => {
      dispatch(UpdateConversation(msg, "", "deleteMessage"));
    },
    [dispatch],
  );

  const resendMessage = useCallback(
    async (message, messageItem) => {
      const time = new Date().toISOString().split(".")[0];
      let messageId = uuidv4();
      const chatMessage = {
        messageid: messageId,
        groupid: selectedRoom.groupid,
        userid: currentUserId,
        messagetext: message,
        attachments: attachmentUrl,
        type: selectedRoom.type,
        senderimage: window.localStorage.getItem("userimageurl"),
        senderfirstname: window.localStorage.getItem("firstname"),
        senderlastname: window.localStorage.getItem("lastname"),
      };
      let newMsg = {
        messageid: messageId,
        senderid: chatMessage.userid,
        messages: message,
        time: time,
        attachments: attachmentUrl,
        type: chatMessage.type,
        senderimage: window.localStorage.getItem("userimageurl"),
        senderfirstname: window.localStorage.getItem("firstname"),
        senderlastname: window.localStorage.getItem("lastname"),
      };
      if (navigator.onLine) {
        handleMessageDelete(messageItem);
        await connection.invoke(
          "SendMessage",
          `${currentCompanyId}-${selectedRoom.groupid}`,
          chatMessage,
        );
        dispatch(UpdateConversation(newMsg));
        updateLocalMessageStatus(messageId, {
          isreceiverreadonly: 1,
          isReceiverReadOnly: 1,
        });
      } else {
        dispatch(UpdateConversation(newMsg, "offline"));
        return;
      }
    },
    [
      selectedRoom,
      currentUserId,
      attachmentUrl,
      currentCompanyId,
      connection,
      dispatch,
      handleMessageDelete,
      navigator,
      UpdateConversation,
    ],
  );

  const deleteImage = () => {
    setImageUrl("");
  };
  const profileUpload = async (file) => {
    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);
    } catch (error) {}
  };
  useEffect(() => {
    dispatch(FetchUsersToGroup());
  }, []);
  const handleOnGroupMemberSelect = (room) => {
    setGroupMember((prevList) => [...prevList, room]);
  };

  const handleOnCreatGroup = () => {
    let reqArray = [{ groupmember: currentUserId }];
    groupMember?.forEach((elements) => {
      reqArray.push({
        groupmember: elements?.userid,
      });
    });
    const formattedDateTime = moment().format("Do MMMM YYYY [at] HH:mm a");
    const groupDicreption = {
      groupDicreption: `${
        "Group created by" +
        " " +
        currentUserName +
        " " +
        currentUserLastName +
        " " +
        "in" +
        " " +
        formattedDateTime
      }`,
    };
    dispatch(
      AddGroups(
        currentUserId,
        groupName,
        groupDicreption?.groupDicreption,
        imageUrl,
        reqArray,
      ),
    );
  };

  window.onpopstate = () => {
    dispatch(EmptyAddGroupState());
  };

  useEffect(() => {
    if (AddGroupsRes?.status === true) {
      setCreateGroupStat(false);
      setGroupName("");
      setImageUrl("");
      setGroupMember([]);
      dispatch(UpdateMessage(currentUserId, AddGroupsRes?.data?.groupid));
      setTimeout(() => {
        // if (searchText) {
        //   setSearchLoading(true);
        //   dispatch(SearchConversations(searchText, currentUserId));
        // } else {
        //   return;
        // }
        dispatch(getChatRooms(currentUserId));
        setSelectedRoom(AddGroupsRes?.data);
      }, 1000);
    }
  }, [AddGroupsRes]);

  useEffect(() => {
    if (GroupInfoReq != null) {
      if (GroupInfoReq?.status === true) {
        if (GroupInfoReq?.grouptype === "Individual") {
          setCoworkerDetails(GroupInfoReq?.data);
          setGroupDetails({});
          setGroupInfoDetail(false);
          setMemberInfoDetail(true);
        } else {
          setGroupDetails(GroupInfoReq?.data);
          setMemberInfoDetail(false);
          setGroupInfoDetail(true);
        }
        updateMentionUsers(GroupInfoReq?.grouptype, GroupInfoReq?.data);
      }
    }
  }, [GroupInfoReq]);

  useEffect(() => {
    if (UserLeaveGroup?.status === true) {
      window.location.reload();
    }
  }, [UserLeaveGroup]);

  const [mentionUsers, setMentionUsers] = useState([]);
  const [, setTaggedUser] = useState([]);
  const updateMentionUsers = (type, data) => {
    const users = [];
    if (type === "Individual") {
      let grpUsers = data.groupuser;
      users.push({
        text: `${grpUsers.firstname}`,
        value: `${grpUsers.firstname}`,
        url: grpUsers.userid,
      });
    }
    if (type === "Group") {
      let grpUsers = data[0].groupuser;
      grpUsers = grpUsers.filter((item) => item.userid !== currentUserId);
      grpUsers.forEach((item) => {
        users.push({
          text: `${item.firstname}`,
          value: `${item.firstname}`,
          url: item.userid,
        });
      });
    }
    setMentionUsers([...users]);
  };

  function handleKeyDown(event) {
    if (event.key === "Enter" && event.shiftKey) {
    } else if (event.key === "Enter") {
      sendMessage();
    } else if (event.ctrlKey && event.keyCode === 13) {
      setVal(val + "\n");
    } else {
      return getDefaultKeyBinding(event);
    }
  }

  const handleReturn = (e, editorState) => {
    if (showEmojiPicker) {
      setShowEmojiPicker(false);
      return true;
    }
    if (!e.shiftKey) {
      sendMessage();
      return true;
    }
    return false;
  };

  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      if (e.key === "Enter" && !e.shiftKey && !showEmojiPicker) {
        // Only trigger if editor is focused
        if (
          document
            .getElementById("chatComntBox")
            ?.contains(document.activeElement)
        ) {
          sendMessage();
        }
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown);
    return () => document.removeEventListener("keydown", handleGlobalKeyDown);
  }, [showEmojiPicker, editorState, selectedRoom, attachmentUrl]);
  const calcHeight = (value) => {
    let numberOfLineBreaks = (value.match(/\n/g) || []).length;
    // min-height + lines x line-height + padding + border
    let newHeight = 19 + numberOfLineBreaks * 19 + 12 + 2;
    return Math.min(newHeight, 95);
  };

  useEffect(() => {
    if (textAreaRef.current) textAreaRef.current.style.height = calcHeight(val) + "px";
  }, [val]);

  const handleMuteNotification = (event) => {
    const groupId = selectedRoom?.groupid;
    const userId = currentUserId;
    const isChecked = event.target.checked;
    const muteMinutes = Number(event.target.value);
    if (groupId) {
      if (isChecked) {
        axiosInstance
          .post(`${API_URL}/api/Chatting/MuteNotification`, {
            groupId,
            userId,
            muteMinutes,
          })
          .then(() => {
            ShowUndoNotification(groupId, selectedRoom.type);
            dispatch(GroupInfo(userId, groupId));
          });
      } else {
        axiosInstance
          .post(`${API_URL}/api/Chatting/UnmuteNotification`, {
            groupId,
            userId,
          })
          .then(() => {
            dispatch(GroupInfo(userId, groupId));
          });
      }
    }
  };

  const getGroupUsers = useMemo(() => {
    let users = "";
    if (
      groupDetails &&
      groupDetails[0] &&
      Array.isArray(groupDetails[0].groupuser)
    ) {
      let gUsers = groupDetails[0].groupuser
        ?.map((gUser) => `${gUser.firstname}`)
        .join(", ");
      users = gUsers;
    }
    return users;
  }, [JSON.stringify(groupDetails)]);

  React.useEffect(() => {
    if (roleModuleData?.status === 200) {
      for (let i = 0; i < roleModuleData?.data?.data?.length; i++) {
        if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976027" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60055"
        ) {
          setCreateAGroupchat(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976024" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60045"
        ) {
          // setMakeactions(true);
        } else if (
          roleModuleData?.data[i]?.moduleid ==
            "08da4e8a-6050-40db-8d54-5751dc976016" &&
          (roleModuleData?.data[i]?.accesslevelsid ==
            "08da33e9-5a64-4f8c-8d88-49e4982df320" ||
            roleModuleData?.data[i]?.accesslevelsid ==
              "08da33e9-5a64-4f8c-8d88-49e4982df321")
        ) {
          // setShowDispatch(true);
        } else if (
          roleModuleData?.data[i]?.moduleid ==
            "08da4e8a-6050-40db-8d54-5751dc976017" &&
          (roleModuleData?.data[i]?.accesslevelsid ==
            "08da33e9-5a64-4f8c-8d88-49e4982df320" ||
            roleModuleData?.data[i]?.accesslevelsid ==
              "08da33e9-5a64-4f8c-8d88-49e4982df321")
        ) {
          // setShowSetting(true);
        }
      }
    } else {
    }
  }, [roleModuleData]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      emojiElementRef.current &&
      !emojiElementRef.current.contains(event.target)
    ) {
      setShowEmojiPicker(false);
    }
  };
  const placeholder = t("Type a message") + "...";

  const [ascShowChat, setAscShowChat] = useState(false);
  const screenSize = useScreenSize();

  // for message delete  👇
  const [deleteCommOpen, setDeleteCommOpen] = useState(false);
  const [commentDeleteID, setCommentDeleteID] = useState("");

  const handleCommDelete = () => {
    dispatch(DeleteMessage(commentDeleteID));
    setDeleteCommOpen(false);
  };

  useEffect(() => {
    if (chatDeleteMessageRes?.status === true) {
      // setProjectData(fetchProjectDropdown?.data);
    }
  }, [chatDeleteMessageRes]);

  const Section = ({ title, children, className }) => (
    <div className={className}>
      <p
        className="search-heading"
        style={{ padding: "10px 10px", margin: "0" }}
      >
        {title}
      </p>
      {children}
    </div>
  );

  const [searchPeople, setSearchPeople] = useState("");

  return (
    <>
      <Header hideSearch={true} />

      {deleteCommOpen && (
        <TaskDelete
          animation={true}
          handleDelete={handleCommDelete}
          show={deleteCommOpen}
          onHide={() => setDeleteCommOpen(false)}
        />
      )}

      <div className="chat-header">
        <div className="chat-div">
          <h6 className="chat-text mt-1 mb-1 mb-lg-4 pb-3">
            {/* chat */}
            {t("Chat")}
          </h6>
          <div className="row">
            <div
              className={
                ascShowChat &&
                (screenSize === "xs" ||
                  screenSize === "sm" ||
                  screenSize === "md")
                  ? "d-none"
                  : "col-lg-3 left-chat-style"
              }
            >
              {createGroupStat && (
                <div className=" left-menu-height" style={{ height: "100%" }}>
                  <div className=" creadgroup-div-main">
                    <div className="text-end">
                      <img
                        src={xCircle}
                        width={25}
                        height={25}
                        alt="#"
                        onClick={() => {
                          setCreateGroupStat(!createGroupStat);
                          setGroupName("");
                          setImageUrl("");
                          setGroupMember([]);
                          setRightSideMenuStat(false);
                        }}
                        className="mx-2 mt-2 cursor-pointer"
                      ></img>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        ref={hiddenFileInput}
                        onChange={(event) => {
                          const fileUploaded = event.target.files[0];
                          if (fileUploaded) {
                            const image = URL.createObjectURL(fileUploaded);
                            profileUpload(fileUploaded);
                          } else {
                            return;
                          }
                        }}
                      />
                      {imageUrl ? (
                        <div
                          className="profile-image"
                          style={{
                            border: "1px solid #707070",
                            // minWidth: "240px",
                            // minHeight: "240px",
                            height: "83px",
                            width: "83px",
                            borderRadius: "50%",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                            src={imageUrl}
                            alt=""
                          />
                        </div>
                      ) : (
                        <div
                          className="profile-image"
                          style={{
                            border: `1px #A5A5A5 dashed`,
                            // minWidth: "240px",
                            // minHeight: "240px",
                            height: "83px",
                            width: "83px",
                            borderRadius: "50%",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "25%",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                          >
                            <AiOutlinePlus
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                color: "#00246A",
                                width: "16px",
                              }}
                              className="responsive-check"
                              onClick={handleClick}
                            />
                            <br />
                            <p className="add-photo-chat" onClick={handleClick}>
                              {/* Add a photo */}
                              {t("Add a photo")}
                            </p>
                          </div>
                        </div>
                      )}
                      {imageUrl && (
                        <>
                          <div className="mt-2">
                            <span className=" mt-2" onClick={handleClick}>
                              {/* Change{" "} */}
                              {t("change")}
                            </span>
                            <span>
                              <RiDeleteBin7Line
                                className="change "
                                style={{
                                  fontSize: "20px",
                                  marginLeft: "0.2rem",
                                  marginBottom: "",
                                }}
                                onClick={deleteImage}
                              />
                            </span>
                          </div>
                        </>
                      )}
                      <div
                        className=" mt-1 mb-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <input
                          className="noborder2 text-center"
                          type="text"
                          placeholder={t("Type a name")} //Type a name
                          style={{
                            color: "#333333",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                          onChange={(e) => {
                            setGroupName(e.target.value);
                          }}
                          value={groupName}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="General-chat-div"
                    style={{
                      height: `calc(100% - ${imageUrl ? "189px" : "157px"})`,
                    }}
                  >
                    {groupMember?.length > 0 && (
                      <div className="group-item-height">
                        {groupMember?.map((tag, index) => {
                          return (
                            <>
                              <span key={index} className="membergroup-style">
                                {`${tag?.firstname + " " + tag?.lastname}`}
                                <span className="cross-icon-style-cross"></span>
                                <BsX
                                  className="times-icon-style-time"
                                  onClick={() => {
                                    let temp = [...groupMember];
                                    temp = temp.filter((item) => item != tag);
                                    setGroupMember(temp);
                                  }}
                                  style={{ height: "20px", width: "20px" }}
                                />
                              </span>
                            </>
                          );
                        })}
                      </div>
                    )}
                    <div
                      className="d-flex align-items-center justify-content-start py-2"
                      style={{ borderBottom: "2px solid #47575726" }}
                    >
                      <Image
                        src={search}
                        alt="#"
                        width={19}
                        height={19}
                        className="mx-3"
                        style={{ opacity: ".5" }}
                      ></Image>
                      <div
                        style={{
                          display: "inline-block",
                          position: "relative",
                          width: "100%",
                        }}
                      >
                        <input
                          type="text"
                          className="input-search-member add-contact-input-style w-100"
                          placeholder={t("Choose members")} //"Choose members"
                          value={addGroupMemberSearch}
                          onChange={(e) =>
                            setAddGroupMemberSearch(
                              e.target.value.toLowerCase(),
                            )
                          }
                        />
                      </div>
                    </div>
                    <div
                      className="chat-people-block "
                      style={{
                        height: `calc(100% - ${
                          groupMember?.length > 0 ? "208px" : "150px"
                        })`,
                        overflowY: "auto",
                        position: "relative",
                      }}
                    >
                      {searchLoading ? (
                        <span>{t("search")}...</span> //Searching...
                      ) : (
                        <>
                          <RoomListWrapperMember
                            chatRooms={
                              FetchUsersToGroupData?.status === true
                                ? FetchUsersToGroupData?.data.filter((item) => {
                                    return item.isactive == 1;
                                  })
                                : ""
                            }
                            loading={isChatRoomLoading}
                            addGroupMemberSearch={addGroupMemberSearch}
                            onSelectMember={(room) => {
                              handleOnGroupMemberSelect(room);
                            }}
                            selectedRoom={selectedRoom}
                            groupMember={groupMember}
                          />
                        </>
                      )}
                    </div>
                    {searchLoading ? (
                      <span>{t("search")}...</span> //Searching...
                    ) : (
                      <div
                        className="group-member-div"
                        style={{
                          position: "sticky",
                          width: "100%",
                          bottom: 0,
                        }}
                      >
                        <button
                          className="invitebtn-add"
                          disabled={
                            groupMember.length === 0 || groupName === ""
                          }
                          onClick={handleOnCreatGroup}
                        >
                          {/* Create */}
                          {t("Create")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {searchStat && (
                <div className=" left-menu-height">
                  <div className=" task-search-div no-border">
                    <div className="d-flex align-items-center w-100">
                      <Image
                        src={search}
                        alt="#"
                        width={15}
                        height={15}
                        style={{ opacity: ".5" }}
                      ></Image>

                      <input
                        type="text"
                        autoFocus={searchStat}
                        style={{
                          outline: "none",
                          margin: "0 0 0 0px",
                          fontSize: "12px",
                          fontWeight: searchText ? "400" : "400",
                          color: searchText ? "#A5A5A5" : "#A5A5A5",
                        }}
                        placeholder="Search or start a conversation"
                        className="search-style ms-2"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                    <img
                      src={xCircle}
                      width={18}
                      height={18}
                      alt="#"
                      onClick={() => {
                        setSearchText("");
                        setSearchStat(false);
                      }}
                      className="m-2 cursor-pointer"
                    ></img>
                  </div>
                  {/* searchable result start*/}
                  <div className="chat-people-block seacrh-active-list">
                    {searchLoading ? (
                      <span className="ps-3">{t("search")}...</span> // Searching...
                    ) : (
                      <>
                        {searchText ? (
                          <>
                            {searchedData?.users?.length > 0 && (
                              <Section title="Users">
                                <RoomListWrapper
                                  chatRooms={searchedData?.users}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.groups?.length > 0 && (
                              <Section title="Groups">
                                <RoomListWrapper
                                  chatRooms={searchedData?.groups}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.messages?.length > 0 && (
                              <Section
                                title="Messages"
                                className="searchedDatamessages"
                              >
                                <RoomListWrapper
                                  chatRooms={searchedData?.messages}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.users?.length === 0 && (
                              // searchedData?.groups?.length === 0 &&
                              // searchedData?.messages?.length === 0 && (
                              <NoResults icon={SearchNoResultSmileIcon} t={t} />
                            )}
                          </>
                        ) : (
                          <RoomListWrapper
                            chatRooms={chatRooms}
                            primaryColor={primaryColor}
                            loading={isChatRoomLoading}
                            onSelect={(room) => handleOnRoomSelect(room)}
                            selectedRoom={selectedRoom}
                            companyId={currentCompanyId}
                            selectChat={setSearchStat}
                            rightSideMenuStat={setRightSideMenuStat}
                            searchStat={setSearchStat}
                            searchConversation={setSearchConversation}
                            setIsAttached={setIsAttached}
                            currentUserId={currentUserId}
                            dispatch={dispatch}
                            setShowAdminDrop={setShowAdminDrop}
                            setAscShowChat={setAscShowChat}
                            NoSearchYet={true}
                            searchText={searchText}
                            searchPeople={searchPeople}
                            setSearchPeople={setSearchPeople}
                          />
                        )}
                      </>
                    )}
                  </div>
                  {/* searchable result end*/}
                </div>
              )}
              {!createGroupStat && !searchStat && (
                <div className=" left-menu-height">
                  {showArchiveChats ? (
                    <div className=" task-search-div no-border">
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div
                          className="archive-header-back-icon"
                          onClick={() => setShowArchiveChats(false)}
                        >
                          <BackArchiveOutlineIcon />
                        </div>
                        <div className="archive-header-label">
                          <ArchiveBlackOutlineIcon />
                          {/* Archive */}
                          {t("Archieve")}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className=" task-search-div no-border">
                      <div className="align-items-center d-flex justify-content-between gap-2 w-100">
                        <Image
                          className="search-left-icon"
                          src={search}
                          alt="#"
                          style={{ opacity: ".5" }}
                        ></Image>

                        <input
                          type="text"
                          placeholder={t("Search or Start a conversation")}
                          value={searchPeople}
                          onChange={(e) => {
                            setSearchPeople(e.target.value);
                          }}
                          style={{
                            // border: "0.5px solid grey",
                            border: "none",
                            borderRadius: "6px",
                            outline: "none",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#A5A5A5",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                            minWidth: 0,
                            paddingInlineStart: "10px",
                          }}
                        />

                        <div
                          className="d-none"
                          onClick={() => {
                            setSearchStat(true);
                          }}
                          style={{
                            outline: "none",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#A5A5A5",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "280px",
                            paddingInlineStart: "10px",
                          }}
                        >
                          {/* search or start a conversion */}
                          {t("Search or Start a conversation")}
                        </div>
                        {createAGroupchat && (
                          <img
                            className="ms-1 add-group-left-icon"
                            src={
                              addGroupHover ? addGroupIconHover : addGroupIcon
                            }
                            alt="#"
                            onMouseOver={() => setAddGroupHover(true)}
                            onMouseOut={() => setAddGroupHover(false)}
                            onClick={() => setCreateGroupStat(!createGroupStat)}
                          />
                        )}
                        <ArchiveChatOptions
                          onShowArchive={() => setShowArchiveChats(true)}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className="chat-people-block "
                    style={{ overflowY: "auto" }}
                  >
                    {searchLoading ? (
                      <span>{t("search")}...</span> //Searching...
                    ) : (
                      <>
                        {searchText ? (
                          <>
                            {searchedData?.users?.length > 0 && (
                              <Section title="Users">
                                <RoomListWrapper
                                  chatRooms={searchedData?.users}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.groups?.length > 0 && (
                              <Section title="Groups">
                                <RoomListWrapper
                                  chatRooms={searchedData?.groups}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.messages?.length > 0 && (
                              <Section title="Messages">
                                <RoomListWrapper
                                  chatRooms={searchedData?.messages}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.users?.length === 0 &&
                              searchedData?.groups?.length === 0 &&
                              searchedData?.messages?.length === 0 && (
                                <p
                                  style={{
                                    padding: "10px 10px",
                                    margin: "0",
                                    textAlign: "center",
                                  }}
                                >
                                  {/* No contacts or message found */}
                                </p>
                              )}
                            {searchedData?.groups?.length > 0 && (
                              <Section title="Groups">
                                <RoomListWrapper
                                  chatRooms={searchedData?.groups}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.messages?.length > 0 && (
                              <Section title="Messages">
                                <RoomListWrapper
                                  chatRooms={searchedData?.messages}
                                  primaryColor={primaryColor}
                                  loading={isChatRoomLoading}
                                  onSelect={(room) => handleOnRoomSelect(room)}
                                  companyId={currentCompanyId}
                                  selectChat={setSearchStat}
                                  rightSideMenuStat={setRightSideMenuStat}
                                  searchStat={setSearchStat}
                                  searchConversation={setSearchConversation}
                                  setIsAttached={setIsAttached}
                                  currentUserId={currentUserId}
                                  dispatch={dispatch}
                                  setShowAdminDrop={setShowAdminDrop}
                                  setAscShowChat={setAscShowChat}
                                  searchText={searchText}
                                  searchPeople={searchPeople}
                                  setSearchPeople={setSearchPeople}
                                />
                              </Section>
                            )}
                            {searchedData?.users?.length === 0 &&
                              searchedData?.groups?.length === 0 &&
                              searchedData?.messages?.length === 0 && (
                                <p
                                  style={{
                                    padding: "10px 10px",
                                    margin: "0",
                                    textAlign: "center",
                                  }}
                                >
                                  {/* No contacts or message found */}
                                </p>
                              )}
                          </>
                        ) : (
                          <>
                            <RoomListWrapper
                              chatRooms={chatRooms || []}
                              primaryColor={primaryColor}
                              loading={isChatRoomLoading}
                              onSelect={(room) => handleOnRoomSelect(room)}
                              selectedRoom={selectedRoom}
                              companyId={currentCompanyId}
                              selectChat={setSearchStat}
                              rightSideMenuStat={setRightSideMenuStat}
                              searchStat={setSearchStat}
                              searchConversation={setSearchConversation}
                              setIsAttached={setIsAttached}
                              currentUserId={currentUserId}
                              showArchive={showArchiveChats}
                              setShowAdminDrop={setShowAdminDrop}
                              // setSearchStat={selectChat}
                              setAscShowChat={setAscShowChat}
                              searchText={searchText}
                              searchPeople={searchPeople}
                              setSearchPeople={setSearchPeople}
                            />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              className={
                ascShowChat &&
                (screenSize === "xs" ||
                  screenSize === "sm" ||
                  screenSize === "md")
                  ? "d-block"
                  : rightSideMenuStat
                    ? "col-lg-6  left-chat-style Chat_HideForMobile Chat_HideForTablet"
                    : "col-lg-9  left-chat-style Chat_HideForMobile Chat_HideForTablet"
              }
            >
              {isAttached ? (
                <DocumentAttachedModal
                  setIsAttached={setIsAttached}
                  setSearchStat={setSearchStat}
                  setAttachmentUrl={setAttachmentUrl}
                  setSearchText={setSearchText}
                  attachedName={attachedName}
                  attachedUrl={attachmentUrl}
                  textAreaRef={textAreaRef}
                  val={val}
                  setVal={setVal}
                  placeholder={placeholder}
                  handleKeyDown={handleKeyDown}
                  editorState={editorState}
                  setEditorState={(val) => {
                    setEditorState(val);
                    setTyping(true);
                  }}
                  attachedSize={attachedSize}
                  showDownArrow={showDownArrow}
                  scrollToBottom={scrollToBottom}
                  mentionUsers={mentionUsers}
                  onFileUploaded={onFileUploaded}
                  setShowEmojiPicker={setShowEmojiPicker}
                  showEmojiPicker={showEmojiPicker}
                  sendMessage={sendMessage}
                  setAttachedName={setAttachedName}
                  setAttachedSize={setAttachedSize}
                />
              ) : (
                <div
                  className={
                    rightSideMenuStat &&
                    (screenSize === "xs" ||
                      screenSize === "sm" ||
                      screenSize === "md")
                      ? "d-none"
                      : ""
                  }
                >
                  <div className="chat-search-style">
                    <div
                      className="d-flex gap-2 p--2 ps-2 pe-4 px-lg-2 pointer d-none Chat_backButton_show"
                      onClick={() => setAscShowChat(false)}
                    >
                      <img src={chatBackIcon} alt="" className="backArrow" />
                    </div>

                    <div
                      className="d-flex gap-2 align-items-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setRightSideMenuStat(true);
                        setGroupInfoDetail(true);
                        setSearchConversation(false);
                      }}
                    >
                      {selectedRoom && (
                        <div
                          className="name-image-style1 temp-image-style"
                          style={{
                            border: "2px solid #FFFFFF",
                            height: "45px",
                            width: "45px",
                          }}
                        >
                          {selectedRoom?.groupicon ? (
                            <img
                              src={selectedRoom?.groupicon}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                zIndex: "0",
                                borderRadius: "100%",
                              }}
                            />
                          ) : (
                            <>
                              {selectedRoom?.groupname && (
                                <span className="groupname-heading">
                                  {selectedRoom?.groupname?.split(" ")[1]
                                    ? `${selectedRoom?.groupname
                                        ?.split(" ")[0][0]
                                        ?.toUpperCase()}${selectedRoom?.groupname
                                        ?.split(" ")[1][0]
                                        ?.toUpperCase()}`
                                    : `${selectedRoom?.groupname
                                        ?.split(" ")[0][0]
                                        ?.toUpperCase()}${selectedRoom?.groupname
                                        ?.split(" ")[0][1]
                                        ?.toUpperCase()}`}
                                </span>
                              )}
                            </>
                          )}
                        </div>
                      )}
                      <div
                        className="d-flex flex-column "
                        style={{ width: "28vw" }}
                      >
                        <div
                          className="name-style info-user-name"
                          style={{
                            color: "#FFFFFF",
                            lineHeight: "21px",
                            textTransform: "capitalize",
                            width: "23vw",
                            fontWeight: 800,
                          }}
                        >
                          {selectedRoom?.groupname}
                        </div>
                        <div
                          className="info-user-name-addtion"
                          style={{
                            color: "#FFFFFF",
                            lineHeight: "21px",
                            fontWeight: 800,
                            textTransform: "capitalize",
                            width: "85%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "515px",
                            // WebkitLineClamp: 1,
                            // WebkitBoxOrient: "vertical",
                            // display: "-webkit-box",
                          }}
                        >
                          {getGroupUsers}
                        </div>
                      </div>
                    </div>
                    <div className="Chat_HideForTablet Chat_HideForMobile">
                      {selectedRoom && searchConversation === false && (
                        <div className="d-flex align-item-center position-relative">
                          <img
                            className="seacr-icon-new"
                            src={chatSearchIcon}
                            onClick={() => {
                              setSearchConversation(true);
                              setRightSideMenuStat(true);
                              setMemberInfoDetail(false);
                              setGroupInfoDetail(false);
                              setSelectedCurrentRoomGroupId(
                                selectedRoom?.groupid,
                              );
                              // dispatch(SearchConversationOnGroup())
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            className="ms-1 add-group-left-icon cursor-pointer"
                            src={addGroupIconHover}
                            alt="action"
                            onClick={() => setShowAction(!showAction)}
                          />
                          {selectedRoom.type === "Group" && (
                            <GroupChatAction
                              taskId={taskId}
                              setTaskId={setTaskId}
                              modalFunction={modalFunction}
                              setModalFunction={setModalFunction}
                              showModal={showModal}
                              setShowModal={setShowModal}
                              onShowAction={() => setShowAction(true)}
                              selectedRoom={selectedRoom}
                              primaryColor={primaryColor}
                              groupDetails={groupDetails}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="chat-messages-block">
                    {selectedRoom ? (
                      isChatMessagesLoading ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <Loader />
                        </div>
                      ) : (
                        <ChatMessages
                          groupedChatConversations={groupedChatConversations}
                          containerRef={containerRef}
                          currentUserId={currentUserId}
                          fetchTransChatList={fetchTransChatList}
                          setShowDownArrow={setShowDownArrow}
                          setShowModal={setShowModal}
                          primaryColor={primaryColor}
                          selectedRoom={selectedRoom}
                          groupDetails={groupDetails}
                          setTaskId={setTaskId}
                          setModalFunction={setModalFunction}
                          setDeleteCommOpen={setDeleteCommOpen}
                          setCommentDeleteID={setCommentDeleteID}
                          resendMessage={resendMessage}
                          handleMessageDelete={handleMessageDelete}
                          hasMoreMessages={hasMoreMessages}
                          aiTyping={aiTyping}
                          academyOptionPending={academyOptionPending}
                          onAcademyOptionSelect={sendAcademyOption}
                          onAcademyVideoComplete={sendAcademyVideoCompletion}
                          isUserTyping={isUserTyping}
                          onMessageVisible={handleVisibleMessageRead}
                          onLoadMore={() => {
                            if (!hasMoreMessages || isLoadingMoreRef.current)
                              return;
                            isLoadingMoreRef.current = true;
                            const newSkip = skip + 10;
                            setSkip(newSkip);
                            dispatch(
                              loadMoreChatConversations(
                                selectedRoom.groupid,
                                currentUserId,
                                newSkip,
                                10,
                              ),
                            ).then(() => {
                              isLoadingMoreRef.current = false;
                            });
                          }}
                        />
                      )
                    ) : (
                      <div className=" d-flex align-items-center flex-column justify-content-center">
                        <Image
                          src={smileChatIcon}
                          width={49}
                          height={48}
                          alt="#"
                        ></Image>
                        <p className="mb-0 chat-welcome mt-4">
                          {t("Welcome")}
                          <br />
                          <span className="chat-welcome-color">
                            {t("Search or Start a conversation")}{" "}
                          </span>
                          <br />
                          {t("to find co-workers to chat with.")}
                        </p>
                      </div>
                    )}
                    <div className="write-message-block-div">
                      {showDownArrow && (
                        <div
                          className="chat-scroll-bottom"
                          onClick={scrollToBottom}
                        >
                          <BsArrowDown color="#707070" />
                        </div>
                      )}
                      <textarea
                        ref={textAreaRef}
                        value={val}
                        onChange={(e) => {
                          setVal(e.target.value);
                          setTyping(true);
                        }}
                        className="write-message d-none"
                        placeholder={placeholder}
                        onKeyDown={handleKeyDown}
                      />

                      <div
                        className="p- col-1-1"
                        id="chatComntBox"
                        // style={{ height: "105px" }}
                      >
                        <Editor
                          placeholder={placeholder}
                          editorState={editorState}
                          onEditorStateChange={changeApplied}
                          handlePastedText={handlePastedText}
                          wrapperClassName="wrapper-class"
                          editorClassName="write-message"
                          toolbarClassName="toolbar-bottom-absolute"
                          toolbar={{
                            options: ["inline"],
                            inline: {
                              options: ["bold", "italic", "underline"],
                              bold: { icon: BoldIcon },
                              italic: { icon: ItalicIcon },
                              underline: { icon: UnderlineIcon },
                            },
                          }}
                          mention={{
                            separator: " ",
                            trigger: "@",
                            suggestions: mentionUsers,
                          }}
                          handleReturn={handleReturn}
                          // keyBindingFn={handleKeyDown}
                        />
                      </div>
                      <div className="write-message-block">
                        <div className="d-flex gap-3"></div>
                        <div className="d-flex gap-3">
                          <DocumentUploaderWithProgress
                            onUploaded={onFileUploaded}
                            maxSizeInMb={100}
                          >
                            <img
                              alt=""
                              src={attachIcon}
                              style={{
                                cursor: "pointer",
                                width: "15px",
                                height: "15px",
                              }}
                            />
                          </DocumentUploaderWithProgress>
                          <div
                            style={{ position: "relative" }}
                            ref={emojiElementRef}
                          >
                            <img
                              alt=""
                              src={emojiIcon}
                              style={{
                                cursor: "pointer",
                                width: "15px",
                                height: "15px",
                              }}
                              onClick={() =>
                                setShowEmojiPicker(!showEmojiPicker)
                              }
                            />
                            {showEmojiPicker && (
                              <div className="emoji-picker-style onKeyDown={(e) => e.stopPropagation()}">
                                <Picker
                                  data={data}
                                  style={{ color: "#8CDBDE" }}
                                  onEmojiSelect={(e) => {
                                    const contentState = Modifier.replaceText(
                                      editorState.getCurrentContent(),
                                      editorState.getSelection(),
                                      e.native,
                                      editorState.getCurrentInlineStyle(),
                                    );
                                    const updatedEditorState = EditorState.push(
                                      editorState,
                                      contentState,
                                      "insert-characters",
                                    );
                                    setEditorState(
                                      EditorState.moveFocusToEnd(
                                        updatedEditorState,
                                      ),
                                    );
                                    setShowEmojiPicker(false);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <div>
                            <img
                              src={smsSendIcon}
                              style={{
                                color: "gray",
                                cursor: "pointer",
                                width: "17px",
                                height: "17px",
                              }}
                              onClick={() => sendMessage()}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {rightSideMenuStat && (
              <div className="col-lg-3 left-chat-style ps-00">
                {memberInfoDetail && (
                  <MemberInfoDetail
                    fetchTransChatList={fetchTransChatList}
                    coworkerDetails={coworkerDetails}
                    handleMuteNotification={handleMuteNotification}
                    rightSideMenuStat={rightSideMenuStat}
                    setRightSideMenuStat={setRightSideMenuStat}
                    setShowAdminDrop={setShowAdminDrop}
                  />
                )}
                {groupInfoDetail && (
                  <GroupInfoDetail
                    fetchTransChatList={fetchTransChatList}
                    handleMuteNotification={handleMuteNotification}
                    rightSideMenuStat={rightSideMenuStat}
                    setRightSideMenuStat={setRightSideMenuStat}
                    setShowAdminDrop={setShowAdminDrop}
                    groupDetails={groupDetails}
                    selectedRoom={selectedRoom}
                    showAdminDrop={showAdminDrop}
                    setAddMemberGroupList={setAddMemberGroupList}
                    setGroupInfoDetail={setGroupInfoDetail}
                    UpdateConversationList={UpdateConversationList}
                    setSelectedRoom={setSelectedRoom}
                  />
                )}
                {searchConversation && (
                  <SearchConversation
                    fetchTransChatList={fetchTransChatList}
                    selectedCurrentRoomGroupId={selectedCurrentRoomGroupId}
                    chatConversationsType={chatConversationsType}
                    setRightSideMenuStat={setRightSideMenuStat}
                    setChatConversationsType={setChatConversationsType}
                    setSearchConversation={setSearchConversation}
                  />
                )}
                {addMemberGroupList && (
                  <AddMemberToGroup
                    fetchTransChatList={fetchTransChatList}
                    addGroupMemberSearch={addGroupMemberSearch}
                    setAddGroupMemberSearch={setAddGroupMemberSearch}
                    setGroupInfoDetail={setGroupInfoDetail}
                    selectedRoom={selectedRoom}
                    groupDetails={groupDetails}
                    setAddMemberGroupList={setAddMemberGroupList}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const getFormattedMessage = (message) => {
  let htmlMessage = "";
  let convertedHtml = getChatMessageHtml(message);

  // if (convertedHtml != "<p><br></p>") {
  //   htmlMessage = convertedHtml;
  // }
  if (convertedHtml !== "<p><br></p>") {
    // Linkify URLs for dangerouslySetInnerHTML
    const linkify = new LinkifyIt();
    const links = linkify.match(convertedHtml);
    if (links) {
      links.forEach((link) => {
        const linkTag = `<a href="${link.url}" target="_blank" rel="noopener noreferrer" className="blueTxt">${link.url}</a>`;
        convertedHtml = convertedHtml.replace(link.url, linkTag);
      });
    }
    htmlMessage = convertedHtml;
  }
  return htmlMessage;
};

const ChatMessages = memo(
  ({
    groupedChatConversations,
    containerRef,
    currentUserId,
    fetchTransChatList,
    setShowDownArrow,
    setShowModal,
    primaryColor,
    selectedRoom,
    groupDetails,
    setTaskId,
    setModalFunction,
    setDeleteCommOpen,
    setCommentDeleteID,
    handleMessageDelete,
    resendMessage,
    hasMoreMessages,
    onLoadMore,
    onMessageVisible,
    aiTyping,
    isUserTyping,
    academyOptionPending,
    onAcademyOptionSelect,
    onAcademyVideoComplete,
  }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [showExclamation, setShowExclamation] = useState(false);
    const [resendOpacity, setResendOpacity] = useState(false);
    const [deleteOpacity, setDeleteOpacity] = useState(false);
    const t = (key) => fetchTransChatList?.[key] || "";

    const academyBotUserId = selectedRoom?.assistantuserid || SPIRE_ACADEMY.userId;
    const latestAcademyMessageId = getLatestAcademyMessageId(groupedChatConversations, academyBotUserId);

    const RenderGroupUserImage = ({ messageItem }) => {
      return (
        <div className="name-image-style1 temp-image-style me-2 height-width-40">
          {messageItem?.senderimage ? (
            <img
              src={messageItem?.senderimage}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                zIndex: "0",
                borderRadius: "100%",
              }}
            />
          ) : (
            <>
              {messageItem?.senderlastname?.toUpperCase()
                ? messageItem?.senderfirstname.slice(0, 1).toUpperCase() +
                  messageItem?.senderlastname.slice(0, 1).toUpperCase()
                : messageItem?.senderfirstname?.slice(0, 1).toUpperCase() +
                  messageItem?.senderfirstname?.slice(1, 2).toUpperCase()}
            </>
          )}
        </div>
      );
    };

    const handleContainerScroll = (event) => {
      const el = event.target;
      const isAtBottom = el.scrollTop === 0;
      const isAtTop =
        Math.abs(el.scrollTop) + el.clientHeight >= el.scrollHeight - 2;

      setShowDownArrow(!isAtBottom);

      if (isAtTop && hasMoreMessages) {
        onLoadMore();
      }
    };

    const getInitials = (name) => {
      if (!name || name.length === 0 || typeof name !== "string") {
        return " ";
      }
      const hasSpace = name.includes(" ") && name.split(" ")[1]?.length > 0;
      if (hasSpace) {
        const initials = name
          .split(" ")
          .map((word) => word.charAt(0))
          .join("")
          .toUpperCase();

        return initials;
      } else {
        return name.slice(0, 2).toUpperCase();
      }
    };

    const editContactInfo = (contactId) => {
      {
        dispatch(RemoveDocsClientById());
        dispatch(EmptyProductPart());
        window.localStorage.removeItem("clientaddname");
        window.localStorage.removeItem("clientId2");
        window.localStorage.removeItem("_tmpCon");
        window.localStorage.setItem("selectedGroupId", selectedRoom?.groupid);
        history.push(`/contactlist/edit-contact/${contactId}`, {
          chatWidgetContact: true,
        });
        dispatch(
          globalChat({
            currentUserId,
            groupid: selectedRoom?.groupid ?? "",
            groupicon: selectedRoom?.groupicon ?? "",
            groupname: groupDetails[0].groupname,
            primarycolor: primaryColor,
          }),
        );
      }
    };

    const handleMessageVisible = (visible, messageItem) => {
      if (visible) onMessageVisible?.(messageItem);
    };

    return (
      <div
        className="chat-messages"
        ref={containerRef}
        onScroll={handleContainerScroll}
      >
        {/* Spire typing indicator */}
        {aiTyping && (
          <div className="">
            <img src={ChatGPTGirl} alt="" width={50} />
            <img src={typingLoader} alt="" width={50} />
          </div>
        )}

        {/* user typing indicator */}
        {isUserTyping && (
          <div className="">
            {selectedRoom?.type === "Group" ? (
              "Someone is typing..."
            ) : (
              // : "Typing..."}
              <img src={typingLoader} alt="" width={50} />
            )}
            {/* <img src={typingLoader} alt="" width={50} /> */}
          </div>
        )}

        {groupedChatConversations?.map((message, index) => {
          return (
            <React.Fragment key={message?.date || index}>
              {message?.messages?.map((messageItem, i) => {
                // console.log("asc556 msg item", messageItem);
                const isMyMessage = messageItem?.senderid == currentUserId;
                const academyReply = !isMyMessage &&
                  messageItem?.senderid?.toLowerCase() === academyBotUserId?.toLowerCase()
                    ? getAcademyReply(messageItem.messages) : null;
                const msgClass = isMyMessage
                  ? `incoming-message outgoing-message `
                  : `incoming-message`;
                const isTaskDetails =
                  messageItem?.taskdetail && messageItem.taskdetail[0]
                    ? messageItem?.taskdetail[0]
                    : [];
                const isContactDetail =
                  messageItem?.contactdetail && messageItem.contactdetail[0]
                    ? messageItem?.contactdetail[0]
                    : [];
                if (messageItem?.isdraft) return;
                return (
                  <React.Fragment key={messageItem?.messageid || i}>
                    {messageItem?.messages === "Conversation Started" ? (
                      messageItem.type === "Group" ? (
                        <>
                          <div
                            className={
                              groupedChatConversations.length > 1 ||
                              message?.messages.length > 1
                                ? "d-none"
                                : "view-smiley"
                            }
                          >
                            <div className="messages-date-div">
                              <img
                                src={smileChatIcon}
                                alt="smali"
                                width={50}
                                height={50}
                                className="mt-5 "
                              />
                              <div
                                className="message-date-style"
                                style={{
                                  background: `transparent`,
                                  opacity: "50%",
                                  color: "#333333",
                                  width: "auto",
                                  marginTop: "15px",
                                }}
                              >
                                {t("This group doesn't have any message")}
                                <br />
                                <b style={{ color: "#00246A" }}>
                                  {t("Start a conversation")}
                                </b>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className={
                              message?.messages.length > 1 ||
                              groupedChatConversations.length > 1
                                ? "d-none"
                                : "view-smiley"
                            }
                          >
                            <div className="messages-date-div">
                              <img
                                src={smileChatIcon}
                                alt="smali"
                                width={50}
                                height={50}
                                className="mt-5 "
                              />
                              <div
                                className="message-date-style"
                                style={{
                                  background: `transparent`,
                                  opacity: "50%",
                                  color: "#00246A",
                                }}
                              >
                                {messageItem?.messages}
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    ) : (
                      <ReactVisibilitySensor
                        onChange={(visible) =>
                          handleMessageVisible(visible, messageItem)
                        }
                      >
                        <div
                          key={messageItem?.messageid}
                          className={`d-flex div-${messageItem?.messageid}
                                           ${
                                             isMyMessage
                                               ? "justify-content-end"
                                               : ""
                                           }
                                          ${
                                            isTaskDetails?.taskname
                                              ? "justify-content-center"
                                              : ""
                                          }
                                          ${
                                            isContactDetail?.contactid
                                              ? "justify-content-center"
                                              : ""
                                          }`}
                        >
                          {messageItem?.type === "Group" &&
                            !isMyMessage &&
                            !isTaskDetails?.taskname &&
                            !isContactDetail?.contactid && (
                              <RenderGroupUserImage messageItem={messageItem} />
                            )}
                          {isContactDetail?.contactid && (
                            <div
                              className="task-single-card"
                              onClick={() =>
                                editContactInfo(isContactDetail?.contactid)
                              }
                            >
                              <div className="task-card-content">
                                <div
                                  className="task-card-details-grid"
                                  style={{
                                    gridTemplateColumns:
                                      "1.5fr auto !important",
                                  }}
                                >
                                  <div className="ps-2">
                                    <p
                                      className="task-card-task-name task-name-wrapper"
                                      style={{ width: "auto" }}
                                    >
                                      Contact Added:{" "}
                                      {`${isContactDetail?.firstname} ${isContactDetail?.lastname}`}
                                    </p>
                                    <div>
                                      <p className="task-card-sub-name">
                                        {
                                          isContactDetail?.contactclients[0]
                                            ?.clientname
                                        }
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {isTaskDetails?.taskname && (
                            <div
                              className="task-single-card"
                              onClick={() => {
                                setShowModal(true);
                                setTaskId(isTaskDetails.taskid);
                                setModalFunction("update");
                              }}
                            >
                              <div
                                className="task-card-color"
                                style={{
                                  backgroundColor:
                                    isTaskDetails?.priorityid ===
                                    process.env.REACT_APP_TASK_PRIORITY_EXTREME
                                      ? "#F76767"
                                      : isTaskDetails?.priorityid ===
                                          process.env
                                            .REACT_APP_TASK_PRIORITY_HIGH
                                        ? "#95A7C6"
                                        : isTaskDetails?.priorityid ===
                                            process.env
                                              .REACT_APP_TASK_PRIORITY_LOW
                                          ? "#EAEAEA"
                                          : isTaskDetails?.priorityid ===
                                              process.env
                                                .REACT_APP_TASK_PRIORITY_NORMAL
                                            ? " #D2DCE9"
                                            : "#f8f1bc",
                                }}
                              ></div>

                              <div className="task-card-content">
                                <div className="task-card-details-grid custom-task-grid-chat-widget">
                                  <div className="ps-2">
                                    <p
                                      className="task-card-task-name task-name-wrapper"
                                      style={{ width: "auto" }}
                                    >
                                      {`Task Created: ${isTaskDetails?.taskname}`}
                                    </p>
                                    <div>
                                      <p className="task-card-sub-name">
                                        {isTaskDetails?.contactdetail
                                          ?.clientdetail?.clientname == null ||
                                        undefined
                                          ? isTaskDetails?.contactdetail
                                              ?.contactname
                                          : `${
                                              Boolean(
                                                isTaskDetails?.contactdetail
                                                  ?.contactname,
                                              )
                                                ? `${isTaskDetails?.contactdetail?.contactname} | `
                                                : ""
                                            } ${
                                              isTaskDetails?.contactdetail
                                                ?.clientdetail?.clientname
                                            }`}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "end",
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    {isTaskDetails?.assigneedata?.length >
                                      3 && (
                                      <div
                                        className="task-card-image"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor: "#00246A",
                                          border: "none",
                                          color: "#FFFFFF",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        +
                                        {isTaskDetails?.assigneedata?.length -
                                          3}
                                      </div>
                                    )}
                                    {isTaskDetails?.assigneedata?.length <= 3 &&
                                      isTaskDetails?.assigneedata?.map(
                                        (assignee, i) => {
                                          const hasImageUrl =
                                            assignee.imageurl &&
                                            assignee.imageurl.length > 0;

                                          return (
                                            <div
                                              key={`assignee-${i}`}
                                              className="assignee-container"
                                            >
                                              {hasImageUrl ? (
                                                <img
                                                  alt=""
                                                  className="task-card-image"
                                                  src={assignee.imageurl}
                                                  style={{
                                                    border: `2px ${primaryColor} solid`,
                                                  }}
                                                />
                                              ) : (
                                                <div
                                                  className="assignee-container"
                                                  style={{
                                                    marginLeft: "-8px",
                                                    border: "2px solid white",
                                                    backgroundColor: "#95A7C6",
                                                    height: "38px",
                                                    width: "38px",
                                                    borderRadius: "50px",
                                                    color: "white",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  {getInitials(
                                                    assignee.assigneeName,
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        },
                                      )}
                                    {isTaskDetails?.assigneedata?.length > 3 &&
                                      isTaskDetails?.assigneedata?.map(
                                        (assignee, i) => {
                                          const hasImageUrl =
                                            assignee.imageurl &&
                                            assignee.imageurl.length > 0;

                                          return (
                                            i < 3 && (
                                              <div
                                                key={`assignee-${i}`}
                                                className="assignee-container"
                                              >
                                                {hasImageUrl ? (
                                                  <img
                                                    alt=""
                                                    className="task-card-image"
                                                    src={assignee.imageurl}
                                                    style={{
                                                      border: `2px ${primaryColor} solid`,
                                                    }}
                                                  />
                                                ) : (
                                                  <div
                                                    className="assignee-container"
                                                    style={{
                                                      marginLeft: "-8px",
                                                      border: "2px solid white",
                                                      backgroundColor:
                                                        "#95A7C6",
                                                      height: "38px",
                                                      width: "38px",
                                                      borderRadius: "50px",
                                                      color: "white",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {getInitials(
                                                      assignee.assigneeName,
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            )
                                          );
                                        },
                                      )}
                                  </div>
                                </div>
                                <div></div>
                              </div>
                            </div>
                          )}
                          {!isTaskDetails?.taskname &&
                            !isContactDetail?.contactid && (
                              <div
                                className={msgClass}
                                key={`room-message-${i}`}
                              >
                                <div
                                  className="message-time-grid"
                                  style={{
                                    columnGap: messageItem?.sendingError
                                      ? "0"
                                      : "20px",
                                  }}
                                >
                                  {messageItem?.type === "Group" &&
                                    messageItem?.senderid != currentUserId && (
                                      <p
                                        className="table-item mb-0 "
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                          marginTop: "0px",
                                          color: "#00246A",
                                        }}
                                      >{`${messageItem?.senderfirstname} ${messageItem?.senderlastname}`}</p>
                                    )}
                                  <p className="message-time-style-sms">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: messageItem?.isdeleted
                                          ? "This message was deleted"
                                          : getFormattedMessage(
                                              messageItem?.messages,
                                            ),
                                      }}
                                    ></div>
                                    {!messageItem?.isdeleted && academyReply && (
                                      <AcademyReplyVideo
                                        key={messageItem.messageid}
                                        reply={academyReply}
                                        onComplete={() => onAcademyVideoComplete(academyReply, messageItem.messageid)}
                                      />
                                    )}
                                    {!messageItem?.isdeleted && academyReply && (
                                      <AcademyReplyOptions
                                        reply={academyReply}
                                        disabled={academyOptionPending || aiTyping || messageItem.messageid !== latestAcademyMessageId}
                                        onSelect={(option) => onAcademyOptionSelect(option, academyReply, messageItem.messageid)}
                                      />
                                    )}
                                    {!messageItem?.isdeleted && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          width: "fit-content",
                                        }}
                                      >
                                        {getChatAttachments(messageItem?.attachments).map(
                                          (attachment, index) => (
                                            <a
                                              href={attachment}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              key={index}
                                            >
                                              {attachment.split("/").pop().substring(0, 15)}
                                            </a>
                                          ),
                                        )}
                                      </div>
                                    )}
                                  </p>
                                  <div className="message-time-style">
                                    {!messageItem.isdeleted && (
                                      <span>
                                        {getLocalFormatedTime(
                                          messageItem?.time,
                                          "hh:mm a",
                                        )}
                                        {/* {moment(messageItem?.time).local().format("hh:mm a")} */}
                                      </span>
                                    )}
                                    <div className="pointer">
                                      {currentUserId === messageItem.senderid &&
                                        !messageItem.isdeleted && (
                                          <img
                                            style={{
                                              width: "14px",
                                            }}
                                            src={deleteIcon}
                                            className="ms-1"
                                            alt="dlt"
                                            onClick={() => {
                                              setDeleteCommOpen(true);
                                              setCommentDeleteID(
                                                messageItem.messageid,
                                              );
                                            }}
                                          />
                                        )}
                                    </div>
                                    {isMyMessage && (
                                      <div
                                        style={{
                                          display: "inline-block",
                                          position: "relative",
                                          cursor: "pointer",
                                          transition: "var(--transition)",
                                        }}
                                        onMouseEnter={() => {
                                          setShowExclamation(true);
                                        }}
                                        onMouseLeave={() => {
                                          setShowExclamation(false);
                                        }}
                                      >
                                        {messageItem?.sendingError ? (
                                          <>
                                            <AiOutlineExclamationCircle
                                              style={{
                                                fontSize: "14px",
                                                color: "#E67979",
                                                marginLeft: "8px",
                                              }}
                                            />
                                            {showExclamation && (
                                              <div className="exclamation-options">
                                                <div
                                                  style={{
                                                    fontSize: "1.4rem",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={() =>
                                                    setResendOpacity(true)
                                                  }
                                                  onMouseLeave={() =>
                                                    setResendOpacity(false)
                                                  }
                                                >
                                                  <BsArrowUpRightCircle
                                                    style={{
                                                      fontSize: resendOpacity
                                                        ? "1.6rem"
                                                        : "1.4rem",
                                                      transition:
                                                        "var(--transition)",
                                                    }}
                                                    onClick={() => {
                                                      resendMessage(
                                                        messageItem?.messages,
                                                        messageItem,
                                                      );
                                                    }}
                                                  />
                                                  <span
                                                    className="exclamation-send"
                                                    style={{
                                                      opacity: resendOpacity
                                                        ? "1"
                                                        : "0",
                                                      transition:
                                                        "var(--transition)",
                                                    }}
                                                  >
                                                    Resend
                                                  </span>
                                                </div>
                                                <div
                                                  style={{
                                                    fontSize: "1.4rem",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={() =>
                                                    setDeleteOpacity(true)
                                                  }
                                                  onMouseLeave={() =>
                                                    setDeleteOpacity(false)
                                                  }
                                                >
                                                  <RiDeleteBin7Line
                                                    style={{
                                                      fontSize: deleteOpacity
                                                        ? "1.6rem"
                                                        : "1.4rem",
                                                      transition:
                                                        "var(--transition)",
                                                      width: "20px",
                                                      height: "22",
                                                    }}
                                                    onClick={() => {
                                                      handleMessageDelete(
                                                        messageItem,
                                                      );
                                                    }}
                                                  />
                                                  <span
                                                    className="exclamation-send"
                                                    style={{
                                                      opacity: deleteOpacity
                                                        ? "1"
                                                        : "0",
                                                      transition:
                                                        "var(--transition)",
                                                      right: "30px",
                                                    }}
                                                  >
                                                    Delete
                                                  </span>
                                                </div>
                                                <div>
                                                  <AiOutlineExclamationCircle
                                                    size={"1.4rem"}
                                                    color="rgb(230, 121, 121)"
                                                  />
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        ) : isMessageRead(messageItem) ? (
                                          <BiCheckDouble
                                            size={16}
                                            color="#34B7F1"
                                            style={{
                                              marginBottom: "2px",
                                            }}
                                          />
                                        ) : isMessageDelivered(messageItem) ? (
                                          <BiCheckDouble
                                            size={16}
                                            color="#819098" // Grey Double Tick
                                          />
                                        ) : (
                                          <BiCheck
                                            size={16}
                                            color="#819098"
                                            style={{
                                              marginBottom: "2px",
                                            }}
                                          />
                                        )}
                                      </div>
                                    )}
                                    {/* {`${datetime.getHours()}:${datetime.getMinutes()}`} */}
                                  </div>
                                </div>
                              </div>
                            )}
                          {/* typing indicator */}
                          {!isMyMessage && (
                            <div className="d-none">
                              <p>Typing</p>
                            </div>
                          )}
                        </div>
                      </ReactVisibilitySensor>
                    )}
                  </React.Fragment>
                );
              })}
              <div className="messages-date-div py-2">
                <div
                  className="message-date-style"
                  style={{
                    background: `${primaryColor}`,
                  }}
                >
                  {moment(message?.date).format("D MMMM YYYY")}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  },
);
export default ChatWidget;
